/* eslint-disable */
//
// DO NOT MODIFY ME. This code is automatically generated. Execute bb generate-graphql to update me
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '@graphql/utils/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Long: any;
  Timestamp: any;
};

export type AmtMonthMapping = {
  amtDates: Array<AmtDate>;
  monthAndYear: MonthAndYear;
};

export type AmtMonthMappingInput = {
  amtDateMappingId?: InputMaybe<Scalars['String']>;
  monthAndYear: MonthAndYearInput;
};

export type AddSelectionEntriesInput = {
  selectionEntries: ProgramSpecificAddSelectionEntriesInput;
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
};

export type AddSelectionEntriesResponse = {
  error?: Maybe<CmtError>;
  failedSelectionEntries?: Maybe<Array<FailedSelectionEntry>>;
  succeededSelectionEntries?: Maybe<Array<SucceededSelectionEntry>>;
};

export type AfsAddSelectionEntryInput = {
  asin: Scalars['String'];
  selectionEntryId: Scalars['String'];
};

export type AfsSelectionEntry = SelectionEntry & {
  asin: Scalars['String'];
  asinMetadata?: Maybe<AsinMetadataEntry>;
  lastUpdatedTimestamp: Scalars['Timestamp'];
  optimisticLockId: Scalars['Long'];
  rank?: Maybe<Scalars['Long']>;
  selectionEntryId: Scalars['String'];
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
};

export type AfsSelectionResult = SelectionResult & {
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
  selectionMetadataName?: Maybe<Scalars['String']>;
};

export type AfsSelectionResultsInput = {
  selectionGroupId: Scalars['String'];
};

export type AmtDate = {
  date: Scalars['Timestamp'];
  id: Scalars['String'];
};

export type ApplyItemsChangeInput = {
  deleteEntryIds?: InputMaybe<Array<Scalars['String']>>;
  macroplanogramId: Scalars['String'];
  newEntries?: InputMaybe<Array<ItemEntryInput>>;
  storeId: Scalars['String'];
  updateEntries?: InputMaybe<Array<ItemEntryInput>>;
};

export type ApplyItemsChangeResponse = {
  errors: Array<MapError>;
};

export type AsinMetadataEntry = {
  asin: Scalars['String'];
  buyable?: Maybe<Scalars['Boolean']>;
  capacityUnitPerFacing?: Maybe<CapacityUnitPerFacing>;
  casePackSize?: Maybe<Scalars['Float']>;
  dimensions?: Maybe<Dimensions>;
  ean?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isSearchable?: Maybe<Scalars['Boolean']>;
  jumbleFactor?: Maybe<Scalars['Float']>;
  maxProductsInLaneForAF?: Maybe<Scalars['Int']>;
  menuImage?: Maybe<Scalars['String']>;
  merchandisingRestrictions?: Maybe<Array<Maybe<Scalars['String']>>>;
  ourPrice?: Maybe<Currency>;
  packageVariantsImage?: Maybe<Scalars['String']>;
  performanceData?: Maybe<PerformanceData>;
  plu?: Maybe<Scalars['String']>;
  procurable?: Maybe<Scalars['Boolean']>;
  productStackableForAtlas?: Maybe<Scalars['String']>;
  productStackableForLWP?: Maybe<Scalars['String']>;
  receiptImage?: Maybe<Scalars['String']>;
  springTensionForAF?: Maybe<Scalars['Int']>;
  techCompatibilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  temperatureRating?: Maybe<TemperatureRating>;
  tidyOrientations?: Maybe<Array<Maybe<TidyOrientation>>>;
  title?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<UnitPrice>;
  upc?: Maybe<Scalars['String']>;
  upce?: Maybe<Scalars['String']>;
  uph?: Maybe<Uph>;
  weightInGrams?: Maybe<Scalars['Float']>;
};

export type AssortmentEntry = {
  asin: Scalars['String'];
  asinMetadata?: Maybe<AsinMetadataEntry>;
  categoryId?: Maybe<Scalars['String']>;
  endTime: Scalars['Timestamp'];
  entryId: Scalars['String'];
  facingUnits?: Maybe<Scalars['Long']>;
  fohCapacity?: Maybe<Scalars['Long']>;
  isDraft: Scalars['Boolean'];
  locationNotes?: Maybe<Scalars['String']>;
  macroplanogramId: Scalars['String'];
  recommendedAction?: Maybe<AssortmentEntryRecommendation>;
  startTime: Scalars['Timestamp'];
  storeId: Scalars['String'];
  subcategoryId?: Maybe<Scalars['String']>;
};

export enum AssortmentEntryAction {
  Add = 'ADD',
  Keep = 'KEEP',
  Notactionable = 'NOTACTIONABLE',
  Remove = 'REMOVE'
}

export type AssortmentEntryRecommendation = {
  action: AssortmentEntryAction;
  note?: Maybe<Scalars['String']>;
};

export type AssortmentFacing = {
  asin: Scalars['String'];
  categoryId?: InputMaybe<Scalars['String']>;
  facingUnits: Scalars['Long'];
  fohCapacity: Scalars['Long'];
  subcategoryId?: InputMaybe<Scalars['String']>;
};

export type AssortmentFacingUpdate = {
  entryId: Scalars['String'];
  facingUnits: Scalars['Long'];
  fohCapacity: Scalars['Long'];
};

export type AssortmentSwap = {
  addAssortment?: InputMaybe<Array<AssortmentFacing>>;
  endTime?: InputMaybe<Scalars['Timestamp']>;
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  macroplanogramId: Scalars['String'];
  storeId: Scalars['String'];
  swapTime: Scalars['Timestamp'];
};

export type AssortmentSwapRecommendations = {
  facingUnitsToRemove: Scalars['Long'];
  macroplanogramId: Scalars['String'];
  maxFacingUnits: Scalars['Long'];
  occupiedFacingUnits: Scalars['Long'];
  swapRecommendations: Array<AssortmentEntry>;
};

export type AttributeData = {
  attributeName: Scalars['String'];
  attributeValue: Scalars['String'];
  itemId: Scalars['String'];
  itemIdType: Scalars['String'];
  metadata: Metadata;
};

export type BatchResultData = {
  data?: Maybe<FixtureOrderingData>;
  error?: Maybe<CmtError>;
  program: Scalars['String'];
  storeId: Scalars['String'];
  success: Scalars['Boolean'];
};

export type BatchSwapAssortmentAcrossZoneInput = {
  swapAssortmentInputList: Array<SwapAssortmentInput>;
};

export type BatchSwapAssortmentAcrossZoneResponse = {
  errorMap: Array<MapError>;
};

export type CmtError = {
  errorMessage: Scalars['String'];
  errorType?: Maybe<ErrorType>;
};

export type CapacityUnitPerFacing = {
  capacity?: Maybe<Scalars['Int']>;
  errorMsg?: Maybe<Scalars['String']>;
  jumbleFactor?: Maybe<Scalars['Float']>;
};

export type Category = {
  categoryId: Scalars['String'];
  categoryName: Scalars['String'];
  extraDimensions?: Maybe<Array<Scalars['String']>>;
};

export type ChildAsinEntry = {
  asin?: Maybe<Scalars['String']>;
  buyUnits?: Maybe<Scalars['Long']>;
  orderDate?: Maybe<Scalars['Timestamp']>;
  salesUnits?: Maybe<Scalars['Long']>;
  size: Scalars['String'];
};

export type ChildIdentifierInput = {
  asin?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
};

export type ChildInput = {
  buyUnits?: InputMaybe<Scalars['Long']>;
  id: ChildIdentifierInput;
  orderDate?: InputMaybe<Scalars['Timestamp']>;
  salesUnits?: InputMaybe<Scalars['Long']>;
};

export type CompositeQueryInput = {
  operator: CompositeQueryOperator;
  queryList: Array<SelectionQueryInput>;
};

export enum CompositeQueryOperator {
  And = 'AND',
  Not = 'NOT',
  Or = 'OR'
}

export type CreateCategoryInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  categoryName: Scalars['String'];
  extraDimensions?: InputMaybe<Array<Scalars['String']>>;
  productGroup: Scalars['String'];
};

export type CreateCategoryResponse = {
  category?: Maybe<Category>;
  error?: Maybe<CmtError>;
};

export type CreateSelectionResultInput = {
  createSelectionResultInput: ProgramSpecificCreateSelectionResultInput;
};

export type CreateSelectionResultResponse = {
  error?: Maybe<CmtError>;
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
};

export type CreateSubcategoryInput = {
  categoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export type CreateSubcategoryResponse = {
  error?: Maybe<CmtError>;
  subcategory?: Maybe<Subcategory>;
};

export type CreateZoneTemplateInput = {
  classificationId: Scalars['String'];
  createdBy: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateName: Scalars['String'];
  zones: Array<TemplateZoneConfigInput>;
};

export type CreateZoneTemplateResponse = {
  error?: Maybe<CmtError>;
  success: Scalars['Boolean'];
  templateId?: Maybe<Scalars['ID']>;
};

export type Currency = {
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type DeleteStoreClassificationResponse = {
  error?: Maybe<CmtError>;
  success: Scalars['Boolean'];
};

export type DeleteZoneTemplateResponse = {
  error?: Maybe<CmtError>;
  success: Scalars['Boolean'];
};

export type Dimensions = {
  heightInMillimeters?: Maybe<Scalars['Float']>;
  lengthInMillimeters?: Maybe<Scalars['Float']>;
  widthInMillimeters?: Maybe<Scalars['Float']>;
};

export enum DoorType {
  All = 'ALL',
  Cold = 'COLD',
  Hot = 'HOT'
}

export type ErrorMsg = {
  field: Scalars['String'];
  reason: Scalars['String'];
};

export enum ErrorType {
  ClientError = 'ClientError',
  ConflictError = 'ConflictError',
  DependencyError = 'DependencyError',
  IllegalArgumentError = 'IllegalArgumentError',
  InternalServerError = 'InternalServerError',
  MissingAttributeError = 'MissingAttributeError',
  PartialRequestError = 'PartialRequestError',
  RetryableError = 'RetryableError',
  UserPermissionError = 'UserPermissionError'
}

export type FailedItem = {
  error?: Maybe<SelectionEntryError>;
  itemIdWithType: ItemIdWithType;
  selectionEntryId?: Maybe<Scalars['String']>;
};

export type FailedPassItem = {
  attributeName: Scalars['String'];
  attributeValue?: Maybe<Scalars['String']>;
  error?: Maybe<PassError>;
  itemId: Scalars['String'];
  itemIdType: ItemIdType;
};

export type FailedSelectionEntry = {
  error?: Maybe<SelectionEntryError>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  optimisticLockId?: Maybe<Scalars['Long']>;
  selectionEntryId: Scalars['String'];
};

export enum FilterOperator {
  Contains = 'CONTAINS',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  Prefix = 'PREFIX'
}

export type FixtureConfig = {
  facings: Scalars['Int'];
  fixtureType: Scalars['String'];
  id: Scalars['String'];
};

export type FixtureConfigInput = {
  facings: Scalars['Int'];
  fixtureType: Scalars['String'];
  id: Scalars['String'];
};

export type FixtureData = {
  categories?: Maybe<Array<Scalars['String']>>;
  department?: Maybe<Scalars['String']>;
  depth?: Maybe<Scalars['Float']>;
  dropZone?: Maybe<Scalars['String']>;
  fixtureType?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isAgile?: Maybe<Scalars['Boolean']>;
  model?: Maybe<Scalars['String']>;
  pickPathId?: Maybe<Scalars['String']>;
  rotation?: Maybe<Scalars['Float']>;
  tempZone?: Maybe<Scalars['String']>;
  translation?: Maybe<Array<Scalars['Float']>>;
  width?: Maybe<Scalars['Float']>;
};

export type FixtureEntry = {
  fixtureId: Scalars['String'];
  fixtureType: Scalars['String'];
  sequenceOrder: Scalars['Int'];
};

export type FixtureEntryInput = {
  fixtureId: Scalars['String'];
  fixtureType: Scalars['String'];
  sequenceOrder: Scalars['Int'];
};

export type FixtureOrderingData = {
  department?: Maybe<Scalars['String']>;
  fixtures: Array<FixtureEntry>;
  program: Scalars['String'];
  storeId: Scalars['String'];
};

export type FixtureOrderingRequestInput = {
  department?: InputMaybe<Scalars['String']>;
  program: Scalars['String'];
  storeId: Scalars['String'];
};

export type Floorplan = {
  externalId?: Maybe<Scalars['String']>;
  fixtures: Array<FixtureData>;
  floorplanId?: Maybe<Scalars['String']>;
  goLiveDate?: Maybe<Scalars['String']>;
  isLive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type GetAmtInboundOutboundMappingResponse = {
  inboundMonthMapping?: Maybe<Array<AmtMonthMapping>>;
  outboundMonthMapping?: Maybe<Array<AmtMonthMapping>>;
};

export type GetAsinMetadataInput = {
  asinList: Array<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  storeId: Scalars['String'];
  zoneMapConfigId?: InputMaybe<Scalars['String']>;
  zoneName?: InputMaybe<Scalars['String']>;
};

export type GetAsinMetadataResponse = {
  asinMetadata?: Maybe<Array<AsinMetadataEntry>>;
  error?: Maybe<CmtError>;
};

export type GetAssortmentDiffInput = {
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  macroplanogramIds: Array<Scalars['String']>;
  productEntries: Array<ProductEntry>;
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
};

export type GetAssortmentDiffResponse = {
  assortmentRecommendations?: Maybe<Array<AssortmentEntry>>;
  error?: Maybe<CmtError>;
};

export type GetAssortmentSwapRecommendationsInput = {
  addAssortment?: InputMaybe<Array<AssortmentFacing>>;
  endTime?: InputMaybe<Scalars['Timestamp']>;
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  macroplanogramId: Scalars['String'];
  storeId: Scalars['String'];
  swapTime: Scalars['Timestamp'];
};

export type GetAssortmentSwapRecommendationsResponse = {
  facingUnitsToRemove: Scalars['Long'];
  maxFacingUnits: Scalars['Long'];
  occupiedFacingUnits: Scalars['Long'];
  swapRecommendations: Array<AssortmentEntry>;
};

export type GetBatchAssortmentSwapRecommendationsInput = {
  batchAssortmentSwap: Array<AssortmentSwap>;
};

export type GetBatchAssortmentSwapRecommendationsResponse = {
  errorMap: Array<MapError>;
  swapRecommendations: Array<AssortmentSwapRecommendations>;
};

export type GetBatchFixtureOrderingResponse = {
  results: Array<BatchResultData>;
};

export type GetCategoryInput = {
  productGroup: Scalars['String'];
};

export type GetCategoryResponse = {
  category?: Maybe<Array<Category>>;
  error?: Maybe<CmtError>;
  subcategory?: Maybe<Array<Subcategory>>;
};

export type GetFixtureOrderingResponse = {
  data?: Maybe<FixtureOrderingData>;
  error?: Maybe<CmtError>;
};

export type GetFloorplanInput = {
  date?: InputMaybe<Scalars['Timestamp']>;
  includeFuture?: InputMaybe<Scalars['Boolean']>;
  includePast?: InputMaybe<Scalars['Boolean']>;
  storeId: Scalars['String'];
};

export type GetFloorplanResponse = {
  error?: Maybe<CmtError>;
  floorplans?: Maybe<Array<Floorplan>>;
};

export type GetItemEntriesInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  includeFuture: Scalars['Boolean'];
  macroplanogramId?: InputMaybe<Scalars['String']>;
  maxResult?: InputMaybe<Scalars['Int']>;
  paginationToken?: InputMaybe<Scalars['String']>;
  storeId: Scalars['String'];
  subcategoryId?: InputMaybe<Scalars['String']>;
  timestamp: Scalars['Timestamp'];
};

export type GetItemEntriesResponse = {
  items?: Maybe<Array<ItemEntry>>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type GetItemMetaDataInput = {
  itemIds: Array<Scalars['String']>;
  itemType: ItemType;
  storeId: Scalars['String'];
};

export type GetItemMetaDataResponse = {
  error?: Maybe<CmtError>;
  items?: Maybe<Array<ItemMetaDataEntry>>;
};

export type GetMacroAssortmentInput = {
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  includeFuture: Scalars['Boolean'];
  macroplanogramId?: InputMaybe<Scalars['String']>;
  maxResult?: InputMaybe<Scalars['Int']>;
  paginationToken?: InputMaybe<Scalars['String']>;
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
};

export type GetMacroAssortmentResponse = {
  assortment?: Maybe<Array<AssortmentEntry>>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type GetMacroplanogramInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  includeDraft: Scalars['Boolean'];
  includeFuture: Scalars['Boolean'];
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
};

export type GetMacroplanogramResponse = {
  macroplanogram?: Maybe<Array<MacroplanogramEntry>>;
};

export type GetPlanDiffInput = {
  macroplanogramId: Scalars['String'];
  plan: Array<PlanEntryInput>;
  startTime: Scalars['Timestamp'];
  storeId: Scalars['String'];
};

export type GetPlanDiffResponse = {
  deletedEntries?: Maybe<Array<PlanDiffEntry>>;
  endedEntries?: Maybe<Array<PlanDiffEntry>>;
  extendedEntries?: Maybe<Array<PlanDiffEntry>>;
  newEntries?: Maybe<Array<PlanDiffEntry>>;
};

export type GetProductAttributeInput = {
  attributeName: Scalars['String'];
  attributeValue?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  itemIdType?: InputMaybe<ItemIdType>;
  maxResults?: InputMaybe<Scalars['Int']>;
  paginationToken?: InputMaybe<Scalars['String']>;
  scopeId: Scalars['String'];
  scopeType: ScopeType;
};

export type GetProductAttributeResponse = {
  attributes?: Maybe<Array<AttributeData>>;
  error?: Maybe<CmtError>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type GetProductGroupsResponse = {
  error?: Maybe<CmtError>;
  productGroups?: Maybe<Array<Maybe<ProductGroup>>>;
};

export type GetProgramStoresResponse = {
  error?: Maybe<CmtError>;
  stores?: Maybe<Array<Store>>;
};

export type GetSelectionEntriesInput = {
  paginationToken?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<SelectionQueryInput>;
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
  sortingAndFiltering?: InputMaybe<ProgramSpecificSortingAndFilteringInput>;
};

export type GetSelectionEntriesResponse = {
  error?: Maybe<CmtError>;
  selectionEntries?: Maybe<Array<SelectionEntry>>;
  selectionEntriesPaginationToken?: Maybe<Scalars['String']>;
  totalEntries?: Maybe<Scalars['Long']>;
};

export type GetSelectionResultsInput = {
  paginationToken?: InputMaybe<Scalars['String']>;
  selectionResults: ProgramSpecificGetSelectionResultsInput;
};

export type GetSelectionResultsResponse = {
  error?: Maybe<CmtError>;
  paginationToken?: Maybe<Scalars['String']>;
  selectionResults?: Maybe<Array<SelectionResult>>;
};

export type GetStoreClassificationResponse = {
  data?: Maybe<StoreClassification>;
  error?: Maybe<CmtError>;
};

export type GetSubcategoryRecommendationInput = {
  itemIds: Array<Scalars['String']>;
  itemType: Scalars['String'];
  macroplanogramId: Scalars['String'];
  storeId: Scalars['String'];
};

export type GetSubcategoryRecommendationResponse = {
  error?: Maybe<CmtError>;
  recommendations?: Maybe<Array<SubcategoryRecommendation>>;
};

export type GetUserInformationResponse = {
  alias?: Maybe<Scalars['String']>;
  allowedStyleMerchLocationGroup?: Maybe<Array<StyleMerchLocationGroup>>;
  error?: Maybe<CmtError>;
};

export type GetZoneConfigInput = {
  productGroup: Scalars['String'];
  storeId: Scalars['String'];
  zoneMapConfigName: Scalars['String'];
  zoneName: Scalars['String'];
};

export type GetZoneConfigResponse = {
  error?: Maybe<CmtError>;
  zone?: Maybe<ZoneConfig>;
};

export type GetZoneMapConfigInput = {
  productGroup: Scalars['String'];
  storeId: Scalars['String'];
  zoneMapConfigId: Scalars['String'];
  zoneMapConfigName: Scalars['String'];
};

export type GetZoneMapConfigResponse = {
  error?: Maybe<CmtError>;
  zoneMapConfig?: Maybe<ZoneMapConfig>;
};

export type GetZoneTemplateResponse = {
  data?: Maybe<ZoneTemplate>;
  error?: Maybe<CmtError>;
};

export type Identity = {
  actorId: Scalars['String'];
  actorType: Scalars['String'];
};

export type ItemEntry = {
  categoryId?: Maybe<Scalars['String']>;
  endTime: Scalars['Timestamp'];
  entryId: Scalars['String'];
  itemId: Scalars['String'];
  itemMetaDataEntry?: Maybe<ItemMetaDataEntry>;
  itemType: ItemType;
  macroplanogramId: Scalars['String'];
  optimisticLockId?: Maybe<Scalars['Long']>;
  startTime: Scalars['Timestamp'];
  storeId: Scalars['String'];
  subcategoryId?: Maybe<Scalars['String']>;
};

export type ItemEntryInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  endTime: Scalars['Timestamp'];
  entryId?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  itemType: ItemType;
  optimisticLockId?: InputMaybe<Scalars['String']>;
  startTime: Scalars['Timestamp'];
  subcategoryId?: InputMaybe<Scalars['String']>;
};

export enum ItemIdType {
  Asin = 'ASIN',
  TeenAsin = 'TEEN_ASIN',
  VendorProduct = 'VENDOR_PRODUCT'
}

export type ItemIdWithType = {
  id: Scalars['String'];
  type: ItemIdType;
};

export type ItemIdWithTypeInput = {
  id: Scalars['String'];
  type: ItemIdType;
};

export type ItemMetaDataEntry = {
  casePackVolumeInCubicMillimeters?: Maybe<Scalars['Float']>;
  image?: Maybe<Scalars['String']>;
  itemId: Scalars['String'];
  itemType: ItemType;
  title?: Maybe<Scalars['String']>;
};

export enum ItemType {
  Asin = 'ASIN',
  Custom = 'CUSTOM',
  Scancode = 'SCANCODE',
  Sku = 'SKU',
  Upc = 'UPC'
}

export type KeywordQueryInput = {
  field: QueryFields;
  operator: KeywordQueryOperator;
  values: Array<Scalars['String']>;
};

export enum KeywordQueryOperator {
  Contains = 'CONTAINS',
  Match = 'MATCH'
}

export type ListSelectionGroupsInput = {
  paginationToken?: InputMaybe<Scalars['String']>;
};

export type ListSelectionGroupsResponse = {
  error?: Maybe<CmtError>;
  paginationToken?: Maybe<Scalars['String']>;
  selectionGroups?: Maybe<Array<SelectionGroup>>;
};

export type ListStoreClassificationsResponse = {
  data: Array<StoreClassification>;
  error?: Maybe<CmtError>;
};

export type ListZoneTemplatesResponse = {
  error?: Maybe<CmtError>;
  templates: Array<ZoneTemplate>;
};

export type MacroplanogramCapacityValidation = {
  error?: Maybe<CmtError>;
  projectedOccupiedVolumeInCubicMillimeters?: Maybe<Scalars['Float']>;
  totalMacroplanogramVolumeInCubicMillimeters?: Maybe<Scalars['Float']>;
};

export type MacroplanogramEntry = {
  categoryId?: Maybe<Scalars['String']>;
  endTime: Scalars['Timestamp'];
  entryId: Scalars['String'];
  fixtureIds?: Maybe<Array<Scalars['String']>>;
  isCapacityOverrideAllowed?: Maybe<Scalars['Boolean']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  linkId?: Maybe<Scalars['String']>;
  macroplanogramName?: Maybe<Scalars['String']>;
  maxFacingUnits: Scalars['Long'];
  startTime: Scalars['Timestamp'];
  storeId: Scalars['String'];
  storeSubcategories?: Maybe<Array<StoreSubcategory>>;
  zoneMapConfigId?: Maybe<Scalars['String']>;
};

export type MapError = {
  error: CmtError;
  key: Scalars['String'];
};

export type Metadata = {
  timestamp: Scalars['Timestamp'];
  updatedBy: Identity;
};

export type MonthAndYear = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type MonthAndYearInput = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};

/** A root type for mutations */
export type Mutation = {
  addSelectionEntries: AddSelectionEntriesResponse;
  applyItemsChange: ApplyItemsChangeResponse;
  batchSwapAssortmentAcrossZone: BatchSwapAssortmentAcrossZoneResponse;
  createCategory: CreateCategoryResponse;
  createSelectionResult: CreateSelectionResultResponse;
  createSubcategory: CreateSubcategoryResponse;
  /**
   * Create a new zone template in DRAFT status.
   * Template can be edited before publishing.
   */
  createZoneTemplate: CreateZoneTemplateResponse;
  deleteStoreClassification: DeleteStoreClassificationResponse;
  /**
   * Delete a zone template.
   * Only DRAFT templates can be deleted.
   */
  deleteZoneTemplate: DeleteZoneTemplateResponse;
  promoteDraftZone: PromoteDraftZoneResponse;
  publishZone: PublishZoneResponse;
  putStoreClassification: PutStoreClassificationResponse;
  putZoneMapConfig: PutZoneMapConfigResponse;
  storeFixtureOrdering: StoreFixtureOrderingResponse;
  swapAssortment: SwapAssortmentResponse;
  updateFloorplan: UpdateFloorplanResponse;
  updateLocalAttributes: UpdateLocalAttributesResponse;
  updateSelectionEntries: UpdateSelectionEntriesResponse;
  /**
   * Update an existing zone template.
   * Increments version number on successful update.
   * Only DRAFT templates can be updated.
   */
  updateZoneTemplate: UpdateZoneTemplateResponse;
};


/** A root type for mutations */
export type MutationAddSelectionEntriesArgs = {
  addSelectionEntriesInput?: InputMaybe<AddSelectionEntriesInput>;
};


/** A root type for mutations */
export type MutationApplyItemsChangeArgs = {
  applyItemsChangeInput: ApplyItemsChangeInput;
};


/** A root type for mutations */
export type MutationBatchSwapAssortmentAcrossZoneArgs = {
  batchSwapAssortmentAcrossZoneInput?: InputMaybe<BatchSwapAssortmentAcrossZoneInput>;
};


/** A root type for mutations */
export type MutationCreateCategoryArgs = {
  createCategoryInput?: InputMaybe<CreateCategoryInput>;
};


/** A root type for mutations */
export type MutationCreateSelectionResultArgs = {
  createSelectionResultInput?: InputMaybe<CreateSelectionResultInput>;
};


/** A root type for mutations */
export type MutationCreateSubcategoryArgs = {
  createSubcategoryInput?: InputMaybe<CreateSubcategoryInput>;
};


/** A root type for mutations */
export type MutationCreateZoneTemplateArgs = {
  input: CreateZoneTemplateInput;
};


/** A root type for mutations */
export type MutationDeleteStoreClassificationArgs = {
  classificationId: Scalars['String'];
  program: Scalars['String'];
};


/** A root type for mutations */
export type MutationDeleteZoneTemplateArgs = {
  templateId: Scalars['ID'];
  version: Scalars['Int'];
};


/** A root type for mutations */
export type MutationPromoteDraftZoneArgs = {
  promoteDraftZoneInput?: InputMaybe<PromoteDraftZoneInput>;
};


/** A root type for mutations */
export type MutationPublishZoneArgs = {
  publishZoneInput?: InputMaybe<PublishZoneInput>;
};


/** A root type for mutations */
export type MutationPutStoreClassificationArgs = {
  input: PutStoreClassificationInput;
};


/** A root type for mutations */
export type MutationPutZoneMapConfigArgs = {
  putZoneMapConfigInput?: InputMaybe<PutZoneMapConfigInput>;
};


/** A root type for mutations */
export type MutationStoreFixtureOrderingArgs = {
  input: StoreFixtureOrderingInput;
};


/** A root type for mutations */
export type MutationSwapAssortmentArgs = {
  swapAssortmentInput?: InputMaybe<SwapAssortmentInput>;
};


/** A root type for mutations */
export type MutationUpdateFloorplanArgs = {
  input: UpdateFloorplanInput;
};


/** A root type for mutations */
export type MutationUpdateLocalAttributesArgs = {
  updateLocalAttributesInput?: InputMaybe<UpdateLocalAttributesInput>;
};


/** A root type for mutations */
export type MutationUpdateSelectionEntriesArgs = {
  updateSelectionEntriesInput?: InputMaybe<UpdateSelectionEntriesInput>;
};


/** A root type for mutations */
export type MutationUpdateZoneTemplateArgs = {
  input: UpdateZoneTemplateInput;
};

export type PassError = {
  errorMessage: Scalars['String'];
  errorType: PassErrorType;
};

export enum PassErrorType {
  AccessDeniedException = 'AccessDeniedException',
  DependencyFailure = 'DependencyFailure',
  NotFoundException = 'NotFoundException',
  StoreNotFoundException = 'StoreNotFoundException',
  UnauthorizedException = 'UnauthorizedException'
}

export type PlanDiffEntry = {
  categoryId?: Maybe<Scalars['String']>;
  endTime: Scalars['Timestamp'];
  entryId?: Maybe<Scalars['String']>;
  itemId: Scalars['String'];
  itemMetaDataEntry?: Maybe<ItemMetaDataEntry>;
  itemType: ItemType;
  macroplanogramId: Scalars['String'];
  optimisticLockId?: Maybe<Scalars['String']>;
  startTime: Scalars['Timestamp'];
  subcategoryId?: Maybe<Scalars['String']>;
};

export type PlanEntryInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  itemType: ItemType;
  subcategoryId?: InputMaybe<Scalars['String']>;
};

export type ProductEntry = {
  asin: Scalars['String'];
  subcategoryName?: InputMaybe<Scalars['String']>;
};

export type ProductGroup = {
  productGroupId: Scalars['String'];
  productGroupName: Scalars['String'];
};

export enum ProductRelationship {
  Fba = 'FBA',
  Plb = 'PLB',
  Retail = 'Retail'
}

export type ProgramSpecificAddSelectionEntriesInput = {
  afsSelectionEntries?: InputMaybe<Array<AfsAddSelectionEntryInput>>;
  styleSelectionEntries?: InputMaybe<Array<InputMaybe<StyleAddSelectionEntryInput>>>;
};

export type ProgramSpecificCreateSelectionResultInput = {
  styleSelectionResultInput?: InputMaybe<StyleCreateSelectionResultInput>;
};

export type ProgramSpecificGetSelectionResultsInput = {
  afsSelectionResults?: InputMaybe<AfsSelectionResultsInput>;
  styleSelectionResults?: InputMaybe<StyleGetSelectionResultsInput>;
};

export type ProgramSpecificSoftDeleteSelectionEntriesInput = {
  styleSelectionEntries?: InputMaybe<Array<InputMaybe<StyleSoftDeleteSelectionEntryInput>>>;
};

export type ProgramSpecificSortingAndFilteringInput = {
  styleSortingAndFiltering?: InputMaybe<StyleSortingAndFiltering>;
};

export type ProgramSpecificUpdateSelectionEntriesInput = {
  styleSelectionEntries?: InputMaybe<Array<InputMaybe<StyleUpdateSelectionEntryInput>>>;
};

export type PromoteDraftZoneInput = {
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
};

export type PromoteDraftZoneResponse = {
  error?: Maybe<CmtError>;
};

export type PublishZoneInput = {
  isDraft: Scalars['Boolean'];
  macroplanogramName?: InputMaybe<Scalars['String']>;
  storeId: Scalars['String'];
  timestamp: Scalars['Timestamp'];
  zoneMap: Array<Zone>;
  zoneMapConfigId?: InputMaybe<Scalars['String']>;
};

export type PublishZoneResponse = {
  error?: Maybe<CmtError>;
};

export type PutStoreClassificationInput = {
  classificationId: Scalars['String'];
  program: Scalars['String'];
  storeIds: Array<Scalars['String']>;
};

export type PutStoreClassificationResponse = {
  error?: Maybe<CmtError>;
  s3Key?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type PutZoneMapConfigInput = {
  productGroup: Scalars['String'];
  storeId: Scalars['String'];
  zoneMapConfigName: Scalars['String'];
  zones?: InputMaybe<Array<ZoneConfigInput>>;
};

export type PutZoneMapConfigResponse = {
  error?: Maybe<CmtError>;
  success: Scalars['Boolean'];
  zoneMapConfigId?: Maybe<Scalars['String']>;
};

/** A root type for queries */
export type Query = {
  getAMTInboundOutboundMapping: GetAmtInboundOutboundMappingResponse;
  getAsinMetadata: GetAsinMetadataResponse;
  getAssortmentDiff: GetAssortmentDiffResponse;
  getAssortmentSwapRecommendations: GetAssortmentSwapRecommendationsResponse;
  getBatchAssortmentSwapRecommendations: GetBatchAssortmentSwapRecommendationsResponse;
  getBatchFixtureOrdering: GetBatchFixtureOrderingResponse;
  getCategory: GetCategoryResponse;
  getFixtureOrdering: GetFixtureOrderingResponse;
  getFloorplan: GetFloorplanResponse;
  getItemEntries: GetItemEntriesResponse;
  getItemMetaData: GetItemMetaDataResponse;
  getMacroAssortment: GetMacroAssortmentResponse;
  getMacroplanogram: GetMacroplanogramResponse;
  getPlanDiff: GetPlanDiffResponse;
  getProductAttribute: GetProductAttributeResponse;
  getProductGroups: GetProductGroupsResponse;
  getProgramStores: GetProgramStoresResponse;
  getSelectionEntriesForSelectionResult: GetSelectionEntriesResponse;
  getSelectionResults: GetSelectionResultsResponse;
  getStoreClassification: GetStoreClassificationResponse;
  getSubcategoryRecommendation: GetSubcategoryRecommendationResponse;
  getUserInformation: GetUserInformationResponse;
  getZoneConfig: GetZoneConfigResponse;
  getZoneMapConfig: GetZoneMapConfigResponse;
  /**
   * Retrieve a specific zone template by ID and version.
   * Returns null if template not found.
   */
  getZoneTemplate: GetZoneTemplateResponse;
  listSelectionGroups: ListSelectionGroupsResponse;
  listStoreClassifications: ListStoreClassificationsResponse;
  /**
   * List zone templates with optional filtering.
   * Supports filtering by status, classificationId, or program.
   */
  listZoneTemplates: ListZoneTemplatesResponse;
  validateMacroplanogramCapacity: ValidateMacroplanogramCapacityResponse;
};


/** A root type for queries */
export type QueryGetAsinMetadataArgs = {
  getAsinMetadataInput?: InputMaybe<GetAsinMetadataInput>;
};


/** A root type for queries */
export type QueryGetAssortmentDiffArgs = {
  getAssortmentDiffInput?: InputMaybe<GetAssortmentDiffInput>;
};


/** A root type for queries */
export type QueryGetAssortmentSwapRecommendationsArgs = {
  getAssortmentSwapRecommendationsInput?: InputMaybe<GetAssortmentSwapRecommendationsInput>;
};


/** A root type for queries */
export type QueryGetBatchAssortmentSwapRecommendationsArgs = {
  getBatchAssortmentSwapRecommendationsInput?: InputMaybe<GetBatchAssortmentSwapRecommendationsInput>;
};


/** A root type for queries */
export type QueryGetBatchFixtureOrderingArgs = {
  requests: Array<FixtureOrderingRequestInput>;
};


/** A root type for queries */
export type QueryGetCategoryArgs = {
  getCategoryInput?: InputMaybe<GetCategoryInput>;
};


/** A root type for queries */
export type QueryGetFixtureOrderingArgs = {
  department?: InputMaybe<Scalars['String']>;
  program: Scalars['String'];
  storeId: Scalars['String'];
};


/** A root type for queries */
export type QueryGetFloorplanArgs = {
  getFloorplanInput?: InputMaybe<GetFloorplanInput>;
};


/** A root type for queries */
export type QueryGetItemEntriesArgs = {
  getItemEntriesInput?: InputMaybe<GetItemEntriesInput>;
};


/** A root type for queries */
export type QueryGetItemMetaDataArgs = {
  getItemMetaDataInput: GetItemMetaDataInput;
};


/** A root type for queries */
export type QueryGetMacroAssortmentArgs = {
  getMacroAssortmentInput?: InputMaybe<GetMacroAssortmentInput>;
};


/** A root type for queries */
export type QueryGetMacroplanogramArgs = {
  getMacroplanogramInput?: InputMaybe<GetMacroplanogramInput>;
};


/** A root type for queries */
export type QueryGetPlanDiffArgs = {
  getPlanDiffInput: GetPlanDiffInput;
};


/** A root type for queries */
export type QueryGetProductAttributeArgs = {
  getProductAttributeInput?: InputMaybe<GetProductAttributeInput>;
};


/** A root type for queries */
export type QueryGetSelectionEntriesForSelectionResultArgs = {
  getSelectionEntriesInput?: InputMaybe<GetSelectionEntriesInput>;
};


/** A root type for queries */
export type QueryGetSelectionResultsArgs = {
  getSelectionResultsInput?: InputMaybe<GetSelectionResultsInput>;
};


/** A root type for queries */
export type QueryGetStoreClassificationArgs = {
  classificationId: Scalars['String'];
  program: Scalars['String'];
};


/** A root type for queries */
export type QueryGetSubcategoryRecommendationArgs = {
  getSubcategoryRecommendationInput: GetSubcategoryRecommendationInput;
};


/** A root type for queries */
export type QueryGetZoneConfigArgs = {
  getZoneConfigInput?: InputMaybe<GetZoneConfigInput>;
};


/** A root type for queries */
export type QueryGetZoneMapConfigArgs = {
  getZoneMapConfigInput?: InputMaybe<GetZoneMapConfigInput>;
};


/** A root type for queries */
export type QueryGetZoneTemplateArgs = {
  templateId: Scalars['ID'];
  version: Scalars['Int'];
};


/** A root type for queries */
export type QueryListSelectionGroupsArgs = {
  listSelectionGroupsInput?: InputMaybe<ListSelectionGroupsInput>;
};


/** A root type for queries */
export type QueryListStoreClassificationsArgs = {
  program: Scalars['String'];
};


/** A root type for queries */
export type QueryListZoneTemplatesArgs = {
  classificationId?: InputMaybe<Scalars['String']>;
  program?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


/** A root type for queries */
export type QueryValidateMacroplanogramCapacityArgs = {
  validateMacroplanogramCapacityInput: ValidateMacroplanogramCapacityInput;
};

export enum QueryFields {
  Brand = 'Brand',
  Category = 'Category',
  MerchLocation = 'MerchLocation',
  Newness = 'Newness',
  PriceBand = 'PriceBand',
  Region = 'Region',
  SelectionGroupId = 'SelectionGroupId',
  SelectionMetadataId = 'SelectionMetadataId',
  SellerMix = 'SellerMix',
  StoreEndDate = 'StoreEndDate',
  StoreEndDateMonth = 'StoreEndDateMonth',
  StoreEndDateYear = 'StoreEndDateYear',
  StoreId = 'StoreId',
  StoreStartDate = 'StoreStartDate',
  StoreStartDateMonth = 'StoreStartDateMonth',
  StoreStartDateYear = 'StoreStartDateYear',
  Subcategory = 'Subcategory',
  Zone = 'Zone'
}

export type RangeQueryInput = {
  field: QueryFields;
  format?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
};

export enum ScopeType {
  ObfuscatedMarketplaceId = 'OBFUSCATED_MARKETPLACE_ID',
  ObfuscatedMarketplaceIdAndVendorCode = 'OBFUSCATED_MARKETPLACE_ID_AND_VENDOR_CODE',
  StoreId = 'STORE_ID'
}

export enum Season {
  Fall = 'Fall',
  Spring = 'Spring',
  Summer = 'Summer',
  Winter = 'Winter'
}

export type SeasonAndYear = {
  season: Season;
  year: Scalars['String'];
};

export type SelectionEntry = {
  asin?: Maybe<Scalars['String']>;
  asinMetadata?: Maybe<AsinMetadataEntry>;
  lastUpdatedTimestamp: Scalars['Timestamp'];
  optimisticLockId: Scalars['Long'];
  selectionEntryId: Scalars['String'];
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
};

export type SelectionEntryError = {
  errorMessage: Scalars['String'];
  errorType: SelectionEntryErrorType;
};

export enum SelectionEntryErrorType {
  BadRequestError = 'BadRequestError',
  CatalogNotFoundError = 'CatalogNotFoundError',
  DependencyError = 'DependencyError',
  DuplicateEntryError = 'DuplicateEntryError',
  RetryableError = 'RetryableError',
  SelectionEntryNotFoundError = 'SelectionEntryNotFoundError',
  UserPermissionError = 'UserPermissionError',
  ValidationError = 'ValidationError',
  VersionConflictError = 'VersionConflictError'
}

export enum SelectionEntryStatus {
  Curated = 'Curated',
  Cut = 'Cut',
  Forward = 'Forward',
  Placeholder = 'Placeholder'
}

export type SelectionGroup = {
  selectionGroupId: Scalars['String'];
  selectionGroupName?: Maybe<Scalars['String']>;
};

export type SelectionQueryInput = {
  compositeQuery?: InputMaybe<CompositeQueryInput>;
  keywordQuery?: InputMaybe<KeywordQueryInput>;
  rangeQuery?: InputMaybe<RangeQueryInput>;
};

export type SelectionResult = {
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
  selectionMetadataName?: Maybe<Scalars['String']>;
};

export enum SortOrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Store = {
  launchDate?: Maybe<Scalars['String']>;
  storeCode?: Maybe<Scalars['String']>;
  storeId: Scalars['String'];
  storeName?: Maybe<Scalars['String']>;
  warehouseId: Scalars['String'];
};

export type StoreClassification = {
  classificationId: Scalars['String'];
  program: Scalars['String'];
  storeIds: Array<Scalars['String']>;
};

export type StoreFixtureOrderingInput = {
  department?: InputMaybe<Scalars['String']>;
  fixtures: Array<FixtureEntryInput>;
  program: Scalars['String'];
  storeId: Scalars['String'];
};

export type StoreFixtureOrderingResponse = {
  error?: Maybe<CmtError>;
  s3Key?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type StoreSchedule = {
  amtEndDate?: Maybe<Scalars['Timestamp']>;
  amtEndDateMappingId?: Maybe<Scalars['String']>;
  amtStartDate?: Maybe<Scalars['Timestamp']>;
  amtStartDateMappingId?: Maybe<Scalars['String']>;
  inboundMonth?: Maybe<MonthAndYear>;
  outboundMonth?: Maybe<MonthAndYear>;
  presentationStockName?: Maybe<Scalars['String']>;
  storeID: Scalars['String'];
  updatedDate?: Maybe<Scalars['Timestamp']>;
};

export type StoreScheduleInput = {
  endScheduleDate?: InputMaybe<AmtMonthMappingInput>;
  presentationStockName?: InputMaybe<Scalars['String']>;
  startScheduleDate?: InputMaybe<AmtMonthMappingInput>;
  storeID: Scalars['String'];
};

export type StoreSubcategory = {
  capacityPercentage?: Maybe<Scalars['Float']>;
  isCapacityOverrideAllowed?: Maybe<Scalars['Boolean']>;
  maxFacingUnits?: Maybe<Scalars['Long']>;
  subcategoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
  zoneFixtureIds?: Maybe<Array<Scalars['String']>>;
};

export type StyleAddSelectionEntryInput = {
  brand?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  door?: InputMaybe<DoorType>;
  exampleChildAsin?: InputMaybe<Scalars['String']>;
  gl?: InputMaybe<Scalars['String']>;
  merchLocation?: InputMaybe<Scalars['String']>;
  newness?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productPlaceholder?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<ProductRelationship>;
  selectionEntryId: Scalars['String'];
  status?: InputMaybe<SelectionEntryStatus>;
  styleCategory?: InputMaybe<Scalars['String']>;
  styleName?: InputMaybe<Scalars['String']>;
  styleRank?: InputMaybe<Scalars['Long']>;
  styleZone?: InputMaybe<Scalars['String']>;
  subMerchLocation?: InputMaybe<Scalars['String']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  vendorColor?: InputMaybe<Scalars['String']>;
  vendorStyle?: InputMaybe<Scalars['String']>;
};

export type StyleCreateSelectionResultInput = {
  brand?: InputMaybe<Scalars['String']>;
  merchLocationId: Scalars['String'];
  merchLocationName: Scalars['String'];
  season: Season;
  selectionResultOwnerGroup: StyleMerchLocationGroup;
  subMerchLocationId?: InputMaybe<Scalars['String']>;
  subMerchLocationName?: InputMaybe<Scalars['String']>;
  year: Scalars['String'];
};

export type StyleFilterInput = {
  key: StyleSortAndFilterKey;
  operator?: InputMaybe<FilterOperator>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type StyleGetSelectionResultsInput = {
  merchLocationGroups: Array<StyleMerchLocationGroup>;
  seasonAndYear: SeasonAndYear;
};

export enum StyleMerchLocationGroup {
  Men = 'Men',
  Other = 'Other',
  Women = 'Women'
}

export type StyleSelectionEntry = SelectionEntry & {
  GL?: Maybe<Scalars['String']>;
  addedDate?: Maybe<Scalars['Timestamp']>;
  asin?: Maybe<Scalars['String']>;
  asinMetadata?: Maybe<AsinMetadataEntry>;
  availableRetailDate?: Maybe<Scalars['Timestamp']>;
  brand?: Maybe<Scalars['String']>;
  childAsinSizes?: Maybe<Array<Scalars['String']>>;
  children?: Maybe<Array<ChildAsinEntry>>;
  colorRank?: Maybe<Scalars['Long']>;
  department?: Maybe<Scalars['String']>;
  door?: Maybe<DoorType>;
  exampleChildAsin?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isFastTrack?: Maybe<Scalars['Boolean']>;
  isFeaturedMerch?: Maybe<Scalars['Boolean']>;
  isFnSkuFBA?: Maybe<Scalars['Boolean']>;
  lastUpdatedTimestamp: Scalars['Timestamp'];
  matchingSetName?: Maybe<Scalars['String']>;
  merchLocation?: Maybe<Scalars['String']>;
  newness?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  obfuscatedMerchantCustomerId?: Maybe<Scalars['String']>;
  optimisticLockId: Scalars['Long'];
  parentAsin?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  primaryStory?: Maybe<Scalars['String']>;
  productPlaceholder?: Maybe<Scalars['String']>;
  relationship?: Maybe<ProductRelationship>;
  riseForDenim?: Maybe<Scalars['String']>;
  selectionEntryId: Scalars['String'];
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
  shipWindowEndDate?: Maybe<Scalars['Timestamp']>;
  shipWindowStartDate?: Maybe<Scalars['Timestamp']>;
  silhouette?: Maybe<Scalars['String']>;
  simpleColor?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stores?: Maybe<Array<StoreSchedule>>;
  styleCategory?: Maybe<Scalars['String']>;
  styleName?: Maybe<Scalars['String']>;
  styleRank?: Maybe<Scalars['Long']>;
  styleZoneName?: Maybe<Scalars['String']>;
  subMerchLocation?: Maybe<Scalars['String']>;
  teenAsin?: Maybe<Scalars['String']>;
  vendorCode?: Maybe<Scalars['String']>;
  vendorColor?: Maybe<Scalars['String']>;
  vendorPlaceholder?: Maybe<Scalars['String']>;
  vendorStyle?: Maybe<Scalars['String']>;
};

export type StyleSelectionResult = SelectionResult & {
  brand?: Maybe<Scalars['String']>;
  merchLocationId: Scalars['String'];
  merchLocationName: Scalars['String'];
  season: Season;
  selectionEntries?: Maybe<Array<StyleSelectionEntry>>;
  selectionGroupId: Scalars['String'];
  selectionGroupName: Scalars['String'];
  selectionMetadataId: Scalars['String'];
  selectionMetadataName?: Maybe<Scalars['String']>;
  subMerchLocation?: Maybe<Scalars['String']>;
  subMerchLocationId?: Maybe<Scalars['String']>;
  year: Scalars['String'];
};

export type StyleSoftDeleteSelectionEntryInput = {
  optimisticLockId: Scalars['Long'];
  productPlaceholder?: InputMaybe<Scalars['String']>;
  selectionEntryId: Scalars['String'];
  teenAsin?: InputMaybe<Scalars['String']>;
};

export enum StyleSortAndFilterKey {
  Result = 'result',
  SelectionEntryId = 'selectionEntryId',
  Size = 'size'
}

export type StyleSortingAndFiltering = {
  filter?: InputMaybe<Array<StyleFilterInput>>;
  sort?: InputMaybe<Array<StyleSortingInput>>;
};

export type StyleSortingInput = {
  key: StyleSortAndFilterKey;
  order?: InputMaybe<SortOrderType>;
};

export type StyleUpdateSelectionEntryInput = {
  availableRetailDate?: InputMaybe<Scalars['Timestamp']>;
  brand?: InputMaybe<Scalars['String']>;
  childAsinSizes?: InputMaybe<Array<Scalars['String']>>;
  children?: InputMaybe<Array<ChildInput>>;
  colorRank?: InputMaybe<Scalars['Long']>;
  department?: InputMaybe<Scalars['String']>;
  door?: InputMaybe<DoorType>;
  exampleChildAsin?: InputMaybe<Scalars['String']>;
  gl?: InputMaybe<Scalars['String']>;
  isCrossSeasonUpdate: Scalars['Boolean'];
  isFastTrack?: InputMaybe<Scalars['Boolean']>;
  isFeaturedMerch?: InputMaybe<Scalars['Boolean']>;
  isFnSkuFBA?: InputMaybe<Scalars['Boolean']>;
  matchingSetName?: InputMaybe<Scalars['String']>;
  merchLocation?: InputMaybe<Scalars['String']>;
  newness?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  obfuscatedMerchantCustomerId?: InputMaybe<Scalars['String']>;
  optimisticLockId: Scalars['Long'];
  parentAsin?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  primaryStory?: InputMaybe<Scalars['String']>;
  productPlaceholder?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<ProductRelationship>;
  riseForDenim?: InputMaybe<Scalars['String']>;
  selectionEntryId: Scalars['String'];
  shipWindowEndDate?: InputMaybe<Scalars['Timestamp']>;
  shipWindowStartDate?: InputMaybe<Scalars['Timestamp']>;
  silhouette?: InputMaybe<Scalars['String']>;
  simpleColor?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SelectionEntryStatus>;
  stores?: InputMaybe<Array<StoreScheduleInput>>;
  styleCategory?: InputMaybe<Scalars['String']>;
  styleName?: InputMaybe<Scalars['String']>;
  styleRank?: InputMaybe<Scalars['Long']>;
  styleZoneName?: InputMaybe<Scalars['String']>;
  subMerchLocation?: InputMaybe<Scalars['String']>;
  teenAsin?: InputMaybe<Scalars['String']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  vendorColor?: InputMaybe<Scalars['String']>;
  vendorStyle?: InputMaybe<Scalars['String']>;
};

export type Subcategory = {
  categoryId: Scalars['String'];
  subcategoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export type SubcategoryAllocationInput = {
  fixtureIds?: InputMaybe<Array<Scalars['String']>>;
  percentage: Scalars['Int'];
  subcategoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export type SubcategoryFlowStep = {
  capacityPercentage: Scalars['Float'];
  flowOrder: Scalars['Int'];
  isCapacityOverrideAllowed: Scalars['Boolean'];
  subcategoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export type SubcategoryFlowStepInput = {
  capacityPercentage: Scalars['Float'];
  flowOrder: Scalars['Int'];
  isCapacityOverrideAllowed: Scalars['Boolean'];
  subcategoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export type SubcategoryRecommendation = {
  itemId: Scalars['String'];
  reasonCode: Scalars['String'];
  reasonDetail: Scalars['String'];
  subcategoryId: Scalars['String'];
  subcategoryName: Scalars['String'];
};

export type SucceededItem = {
  itemIdWithType: ItemIdWithType;
  optimisticLockId: Scalars['Long'];
  selectionEntryId: Scalars['String'];
};

export type SucceededPassItem = {
  attributeName: Scalars['String'];
  attributeValue?: Maybe<Scalars['String']>;
  itemId: Scalars['String'];
  itemIdType: ItemIdType;
};

export type SucceededSelectionEntry = {
  isDeleted?: Maybe<Scalars['Boolean']>;
  optimisticLockId: Scalars['Long'];
  selectionEntryId: Scalars['String'];
};

export type SwapAssortmentInput = {
  addAssortment: Array<AssortmentFacing>;
  assortmentFacingUpdates: Array<AssortmentFacingUpdate>;
  endTime?: InputMaybe<Scalars['Timestamp']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  macroplanogramId: Scalars['String'];
  storeId: Scalars['String'];
  swapTime: Scalars['Timestamp'];
};

export type SwapAssortmentResponse = {
  error?: Maybe<CmtError>;
};

export enum TemperatureRating {
  Ambient = 'AMBIENT',
  Chilled = 'CHILLED',
  Frozen = 'FROZEN'
}

export type TemplateZoneConfig = {
  subcategoryFlow: Array<SubcategoryFlowStep>;
  zoneName: Scalars['String'];
};

export type TemplateZoneConfigInput = {
  subcategoryFlow: Array<SubcategoryFlowStepInput>;
  zoneName: Scalars['String'];
};

export type TidyOrientation = {
  orientation?: Maybe<Scalars['String']>;
  rotation?: Maybe<Scalars['String']>;
  shelfTech?: Maybe<Scalars['String']>;
};

export type UnitPrice = {
  price?: Maybe<Currency>;
  unit?: Maybe<Scalars['String']>;
};

export type UpdateFloorplanFixtureInput = {
  dropZone?: InputMaybe<Scalars['String']>;
  fixtureId: Scalars['String'];
  pickPathId?: InputMaybe<Scalars['String']>;
  tempZone?: InputMaybe<Scalars['String']>;
};

export type UpdateFloorplanInput = {
  fixtures: Array<UpdateFloorplanFixtureInput>;
  floorplanId: Scalars['String'];
  storeId: Scalars['String'];
};

export type UpdateFloorplanResponse = {
  error?: Maybe<CmtError>;
  floorplanId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateLocalAttributesInput = {
  selectionEntries: Array<UpdateSelectionEntryInput>;
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
};

export type UpdateLocalAttributesResponse = {
  error?: Maybe<CmtError>;
  failedItems?: Maybe<Array<FailedItem>>;
  succeededItems?: Maybe<Array<SucceededItem>>;
};

export type UpdateOrDeleteItem = {
  attributeName: Scalars['String'];
  attributeValue?: InputMaybe<Scalars['String']>;
  itemId: Scalars['String'];
  itemIdType: ItemIdType;
  scopeId: Scalars['String'];
  scopeType: ScopeType;
};

export type UpdateOrDeleteProductAttributeInput = {
  delete: Scalars['Boolean'];
  items: Array<UpdateOrDeleteItem>;
  update: Scalars['Boolean'];
};

export type UpdateOrDeleteProductAttributeResponse = {
  error?: Maybe<CmtError>;
  failedItems?: Maybe<Array<FailedPassItem>>;
  succeededItems?: Maybe<Array<SucceededPassItem>>;
};

export type UpdateSelectionEntriesInput = {
  selectionGroupId: Scalars['String'];
  selectionMetadataId: Scalars['String'];
  softDeletedSelectionEntries: ProgramSpecificSoftDeleteSelectionEntriesInput;
  updatedSelectionEntries: ProgramSpecificUpdateSelectionEntriesInput;
};

export type UpdateSelectionEntriesResponse = {
  error?: Maybe<CmtError>;
  failedSelectionEntries?: Maybe<Array<FailedSelectionEntry>>;
  succeededSelectionEntries?: Maybe<Array<SucceededSelectionEntry>>;
};

export type UpdateSelectionEntryInput = {
  children: Array<ChildInput>;
  itemIdWithType: ItemIdWithTypeInput;
};

export type UpdateZoneTemplateInput = {
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateId: Scalars['ID'];
  templateName?: InputMaybe<Scalars['String']>;
  version: Scalars['Int'];
  zones?: InputMaybe<Array<TemplateZoneConfigInput>>;
};

export type UpdateZoneTemplateResponse = {
  error?: Maybe<CmtError>;
  success: Scalars['Boolean'];
  template?: Maybe<ZoneTemplate>;
};

export type Uph = {
  uphl1?: Maybe<Scalars['String']>;
  uphl2?: Maybe<Scalars['String']>;
  uphl3?: Maybe<Scalars['String']>;
};

export type ValidateMacroplanogramCapacityInput = {
  itemsToAdd?: InputMaybe<Array<PlanEntryInput>>;
  itemsToDelete?: InputMaybe<Array<PlanEntryInput>>;
  macroplanogramId: Scalars['String'];
  startTime: Scalars['Timestamp'];
  storeId: Scalars['String'];
};

export type ValidateMacroplanogramCapacityResponse = {
  capacityValidation?: Maybe<MacroplanogramCapacityValidation>;
};

export type Zone = {
  allocationPercentage?: InputMaybe<Scalars['Float']>;
  allocations?: InputMaybe<Array<SubcategoryAllocationInput>>;
  categoryId?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  facings: Scalars['Long'];
  fixtureIds: Array<Scalars['String']>;
  name: Scalars['String'];
  subcategoryIds: Array<Scalars['String']>;
};

export type ZoneConfig = {
  fixtures?: Maybe<Array<FixtureConfig>>;
  name: Scalars['String'];
};

export type ZoneConfigInput = {
  fixtures?: InputMaybe<Array<FixtureConfigInput>>;
  name: Scalars['String'];
};

export type ZoneMapConfig = {
  name: Scalars['String'];
  zones?: Maybe<Array<ZoneConfig>>;
};

export type ZoneTemplate = {
  classificationId: Scalars['String'];
  createdAt: Scalars['Long'];
  createdBy: Scalars['String'];
  includedStores?: Maybe<Array<Scalars['String']>>;
  program: Scalars['String'];
  publishedAt?: Maybe<Scalars['Long']>;
  publishedStoreCount?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Scalars['String']>>;
  templateId: Scalars['ID'];
  templateName: Scalars['String'];
  templateStatus: Scalars['String'];
  updatedAt: Scalars['Long'];
  version: Scalars['Int'];
  zones: Array<TemplateZoneConfig>;
};

export type PerformanceData = {
  movingAvgSales13week?: Maybe<Scalars['Float']>;
  movingAvgSales26week?: Maybe<Scalars['Float']>;
  movingAvgSales52week?: Maybe<Scalars['Float']>;
  shrinkCost?: Maybe<Scalars['Float']>;
  shrinkPerOps?: Maybe<Scalars['Float']>;
  shrinkPerOps13week?: Maybe<Scalars['Float']>;
  shrinkPerOps26week?: Maybe<Scalars['Float']>;
  shrinkPerOps52week?: Maybe<Scalars['Float']>;
};

export type AddSelectionEntriesMutationVariables = Exact<{
  input: AddSelectionEntriesInput;
}>;


export type AddSelectionEntriesMutation = { addSelectionEntries: { succeededSelectionEntries?: Array<{ selectionEntryId: string, optimisticLockId: any, isDeleted?: boolean | null }> | null, failedSelectionEntries?: Array<{ selectionEntryId: string, optimisticLockId?: any | null, isDeleted?: boolean | null, error?: { errorMessage: string, errorType: SelectionEntryErrorType } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type ApplyItemsChangeMutationVariables = Exact<{
  input: ApplyItemsChangeInput;
}>;


export type ApplyItemsChangeMutation = { applyItemsChange: { errors: Array<{ key: string, error: { errorMessage: string, errorType?: ErrorType | null } }> } };

export type BatchSwapAssortmentAcrossZoneMutationVariables = Exact<{
  input?: InputMaybe<BatchSwapAssortmentAcrossZoneInput>;
}>;


export type BatchSwapAssortmentAcrossZoneMutation = { batchSwapAssortmentAcrossZone: { errorMap: Array<{ key: string, error: { errorMessage: string, errorType?: ErrorType | null } }> } };

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { createCategory: { category?: { categoryId: string, categoryName: string, extraDimensions?: Array<string> | null } | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type CreateSelectionResultMutationVariables = Exact<{
  input: CreateSelectionResultInput;
}>;


export type CreateSelectionResultMutation = { createSelectionResult: { selectionGroupId: string, selectionMetadataId: string, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type CreateSubcategoryMutationVariables = Exact<{
  input: CreateSubcategoryInput;
}>;


export type CreateSubcategoryMutation = { createSubcategory: { subcategory?: { subcategoryId: string, subcategoryName: string, categoryId: string } | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type PublishZoneMutationVariables = Exact<{
  input?: InputMaybe<PublishZoneInput>;
}>;


export type PublishZoneMutation = { publishZone: { error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type PutZoneMapConfigMutationVariables = Exact<{
  input: PutZoneMapConfigInput;
}>;


export type PutZoneMapConfigMutation = { putZoneMapConfig: { success: boolean, zoneMapConfigId?: string | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type SwapAssortmentMutationVariables = Exact<{
  input?: InputMaybe<SwapAssortmentInput>;
}>;


export type SwapAssortmentMutation = { swapAssortment: { error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type UpdateFloorplanMutationVariables = Exact<{
  input: UpdateFloorplanInput;
}>;


export type UpdateFloorplanMutation = { updateFloorplan: { success: boolean, floorplanId?: string | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type UpdateLocalAttributesMutationVariables = Exact<{
  input: UpdateLocalAttributesInput;
}>;


export type UpdateLocalAttributesMutation = { updateLocalAttributes: { succeededItems?: Array<{ optimisticLockId: any, selectionEntryId: string, itemIdWithType: { id: string, type: ItemIdType } }> | null, failedItems?: Array<{ selectionEntryId?: string | null, itemIdWithType: { id: string, type: ItemIdType }, error?: { errorMessage: string, errorType: SelectionEntryErrorType } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type UpdateSelectionEntriesMutationVariables = Exact<{
  input: UpdateSelectionEntriesInput;
}>;


export type UpdateSelectionEntriesMutation = { updateSelectionEntries: { succeededSelectionEntries?: Array<{ selectionEntryId: string, optimisticLockId: any, isDeleted?: boolean | null }> | null, failedSelectionEntries?: Array<{ selectionEntryId: string, optimisticLockId?: any | null, isDeleted?: boolean | null, error?: { errorMessage: string, errorType: SelectionEntryErrorType } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetAmtInboundOutboundMappingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAmtInboundOutboundMappingQuery = { getAMTInboundOutboundMapping: { inboundMonthMapping?: Array<{ monthAndYear: { month: number, year: number }, amtDates: Array<{ date: any, id: string }> }> | null, outboundMonthMapping?: Array<{ monthAndYear: { month: number, year: number }, amtDates: Array<{ date: any, id: string }> }> | null } };

export type GetAsinMetadataQueryVariables = Exact<{
  input: GetAsinMetadataInput;
}>;


export type GetAsinMetadataQuery = { getAsinMetadata: { asinMetadata?: Array<{ asin: string, title?: string | null, image?: string | null, procurable?: boolean | null, buyable?: boolean | null, temperatureRating?: TemperatureRating | null, capacityUnitPerFacing?: { capacity?: number | null, jumbleFactor?: number | null, errorMsg?: string | null } | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetPrsDataQueryVariables = Exact<{
  input: GetAsinMetadataInput;
}>;


export type GetPrsDataQuery = { getAsinMetadata: { asinMetadata?: Array<{ asin: string, title?: string | null, image?: string | null, menuImage?: string | null, packageVariantsImage?: string | null, upc?: string | null, upce?: string | null, gtin?: string | null, ean?: string | null, plu?: string | null, techCompatibilities?: Array<string | null> | null, productStackableForAtlas?: string | null, productStackableForLWP?: string | null, springTensionForAF?: number | null, maxProductsInLaneForAF?: number | null, merchandisingRestrictions?: Array<string | null> | null, weightInGrams?: number | null, isSearchable?: boolean | null, unitPrice?: { unit?: string | null, price?: { unit?: string | null, value?: number | null } | null } | null, ourPrice?: { unit?: string | null, value?: number | null } | null, tidyOrientations?: Array<{ orientation?: string | null, rotation?: string | null, shelfTech?: string | null } | null> | null, dimensions?: { heightInMillimeters?: number | null, lengthInMillimeters?: number | null, widthInMillimeters?: number | null } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetAssortmentDiffQueryVariables = Exact<{
  input: GetAssortmentDiffInput;
}>;


export type GetAssortmentDiffQuery = { getAssortmentDiff: { assortmentRecommendations?: Array<{ asin: string, entryId: string, startTime: any, endTime: any, subcategoryId?: string | null, macroplanogramId: string, facingUnits?: any | null, fohCapacity?: any | null, asinMetadata?: { asin: string, title?: string | null, image?: string | null, procurable?: boolean | null, buyable?: boolean | null, temperatureRating?: TemperatureRating | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, capacityUnitPerFacing?: { capacity?: number | null, errorMsg?: string | null, jumbleFactor?: number | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null } | null, recommendedAction?: { action: AssortmentEntryAction, note?: string | null } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetAssortmentSwapRecommendationsQueryVariables = Exact<{
  input: GetAssortmentSwapRecommendationsInput;
}>;


export type GetAssortmentSwapRecommendationsQuery = { getAssortmentSwapRecommendations: { facingUnitsToRemove: any, maxFacingUnits: any, occupiedFacingUnits: any, swapRecommendations: Array<{ asin: string, entryId: string, subcategoryId?: string | null, macroplanogramId: string, startTime: any, endTime: any, storeId: string, facingUnits?: any | null, fohCapacity?: any | null, asinMetadata?: { asin: string, title?: string | null, image?: string | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null } | null }> } };

export type GetBatchAssortmentSwapRecommendationsQueryVariables = Exact<{
  input: GetBatchAssortmentSwapRecommendationsInput;
}>;


export type GetBatchAssortmentSwapRecommendationsQuery = { getBatchAssortmentSwapRecommendations: { swapRecommendations: Array<{ facingUnitsToRemove: any, maxFacingUnits: any, occupiedFacingUnits: any, macroplanogramId: string, swapRecommendations: Array<{ asin: string, entryId: string, subcategoryId?: string | null, macroplanogramId: string, startTime: any, endTime: any, storeId: string, facingUnits?: any | null, fohCapacity?: any | null, asinMetadata?: { asin: string, title?: string | null, image?: string | null, capacityUnitPerFacing?: { capacity?: number | null, errorMsg?: string | null } | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null } | null }> }>, errorMap: Array<{ key: string, error: { errorMessage: string, errorType?: ErrorType | null } }> } };

export type GetCategoryQueryVariables = Exact<{
  input?: InputMaybe<GetCategoryInput>;
}>;


export type GetCategoryQuery = { getCategory: { category?: Array<{ categoryId: string, categoryName: string, extraDimensions?: Array<string> | null }> | null, subcategory?: Array<{ subcategoryId: string, subcategoryName: string, categoryId: string }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetFloorplanQueryVariables = Exact<{
  input: GetFloorplanInput;
}>;


export type GetFloorplanQuery = { getFloorplan: { floorplans?: Array<{ floorplanId?: string | null, goLiveDate?: string | null, status?: string | null, fixtures: Array<{ id: string, model?: string | null, height?: number | null, width?: number | null, depth?: number | null, rotation?: number | null, translation?: Array<number> | null, department?: string | null, categories?: Array<string> | null, isAgile?: boolean | null, fixtureType?: string | null, pickPathId?: string | null, tempZone?: string | null, dropZone?: string | null }> }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetItemEntriesQueryVariables = Exact<{
  input: GetItemEntriesInput;
}>;


export type GetItemEntriesQuery = { getItemEntries: { paginationToken?: string | null, items?: Array<{ itemId: string, itemType: ItemType, entryId: string, optimisticLockId?: any | null, categoryId?: string | null, subcategoryId?: string | null, macroplanogramId: string, startTime: any, endTime: any, storeId: string, itemMetaDataEntry?: { itemId: string, itemType: ItemType, title?: string | null, image?: string | null } | null }> | null } };

export type GetItemMetaDataQueryVariables = Exact<{
  input: GetItemMetaDataInput;
}>;


export type GetItemMetaDataQuery = { getItemMetaData: { items?: Array<{ itemId: string, itemType: ItemType, title?: string | null, image?: string | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetMacroAssortmentQueryVariables = Exact<{
  input: GetMacroAssortmentInput;
}>;


export type GetMacroAssortmentQuery = { getMacroAssortment: { paginationToken?: string | null, assortment?: Array<{ asin: string, entryId: string, categoryId?: string | null, subcategoryId?: string | null, macroplanogramId: string, startTime: any, endTime: any, storeId: string, facingUnits?: any | null, fohCapacity?: any | null, locationNotes?: string | null, asinMetadata?: { asin: string, title?: string | null, image?: string | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null, performanceData?: { shrinkCost?: number | null, shrinkPerOps?: number | null, shrinkPerOps13week?: number | null, shrinkPerOps26week?: number | null, shrinkPerOps52week?: number | null, movingAvgSales13week?: number | null, movingAvgSales26week?: number | null, movingAvgSales52week?: number | null } | null } | null }> | null } };

export type GetMacroplanogramQueryVariables = Exact<{
  input: GetMacroplanogramInput;
}>;


export type GetMacroplanogramQuery = { getMacroplanogram: { macroplanogram?: Array<{ entryId: string, macroplanogramName?: string | null, startTime: any, endTime: any, storeId: string, fixtureIds?: Array<string> | null, maxFacingUnits: any, isCapacityOverrideAllowed?: boolean | null, isDraft?: boolean | null, zoneMapConfigId?: string | null, linkId?: string | null, categoryId?: string | null, storeSubcategories?: Array<{ subcategoryName: string, subcategoryId: string, zoneFixtureIds?: Array<string> | null, maxFacingUnits?: any | null, capacityPercentage?: number | null, isCapacityOverrideAllowed?: boolean | null }> | null }> | null } };

export type GetPlanDiffQueryVariables = Exact<{
  input: GetPlanDiffInput;
}>;


export type GetPlanDiffQuery = { getPlanDiff: { newEntries?: Array<{ itemId: string, itemType: ItemType, categoryId?: string | null, subcategoryId?: string | null, macroplanogramId: string, startTime: any, endTime: any, itemMetaDataEntry?: { itemId: string, itemType: ItemType, title?: string | null, image?: string | null } | null }> | null, endedEntries?: Array<{ entryId?: string | null, optimisticLockId?: string | null, itemId: string, itemType: ItemType, categoryId?: string | null, subcategoryId?: string | null, macroplanogramId: string, startTime: any, endTime: any, itemMetaDataEntry?: { itemId: string, itemType: ItemType, title?: string | null, image?: string | null } | null }> | null, extendedEntries?: Array<{ entryId?: string | null, optimisticLockId?: string | null, itemId: string, itemType: ItemType, categoryId?: string | null, subcategoryId?: string | null, macroplanogramId: string, startTime: any, endTime: any, itemMetaDataEntry?: { itemId: string, itemType: ItemType, title?: string | null, image?: string | null } | null }> | null, deletedEntries?: Array<{ entryId?: string | null, optimisticLockId?: string | null, itemId: string, itemType: ItemType, categoryId?: string | null, subcategoryId?: string | null, macroplanogramId: string, startTime: any, endTime: any, itemMetaDataEntry?: { itemId: string, itemType: ItemType, title?: string | null, image?: string | null } | null }> | null } };

export type GetProductGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductGroupsQuery = { getProductGroups: { productGroups?: Array<{ productGroupId: string, productGroupName: string } | null> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetProgramStoresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProgramStoresQuery = { getProgramStores: { stores?: Array<{ storeId: string, warehouseId: string, launchDate?: string | null, storeCode?: string | null, storeName?: string | null }> | null } };

export type GetSelectionEntriesForSelectionResultQueryVariables = Exact<{
  input: GetSelectionEntriesInput;
}>;


export type GetSelectionEntriesForSelectionResultQuery = { getSelectionEntriesForSelectionResult: { selectionEntriesPaginationToken?: string | null, totalEntries?: any | null, selectionEntries?: Array<{ __typename: 'AfsSelectionEntry', optimisticLockId: any, selectionEntryId: string, selectionGroupId: string, selectionMetadataId: string, lastUpdatedTimestamp: any, asin: string, asinMetadata?: { asin: string, title?: string | null, image?: string | null, capacityUnitPerFacing?: { capacity?: number | null, errorMsg?: string | null } | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null } | null } | { __typename: 'StyleSelectionEntry', imageUrl?: string | null, addedDate?: any | null, teenAsin?: string | null, productPlaceholder?: string | null, vendorPlaceholder?: string | null, brand?: string | null, vendorCode?: string | null, relationship?: ProductRelationship | null, status?: string | null, parentAsin?: string | null, exampleChildAsin?: string | null, childAsinSizes?: Array<string> | null, vendorStyle?: string | null, styleName?: string | null, vendorColor?: string | null, simpleColor?: string | null, price?: number | null, newness?: string | null, availableRetailDate?: any | null, shipWindowStartDate?: any | null, shipWindowEndDate?: any | null, isFastTrack?: boolean | null, notes?: string | null, GL?: string | null, department?: string | null, merchLocation?: string | null, subMerchLocation?: string | null, door?: DoorType | null, styleZoneName?: string | null, isFeaturedMerch?: boolean | null, matchingSetName?: string | null, silhouette?: string | null, riseForDenim?: string | null, primaryStory?: string | null, styleRank?: any | null, colorRank?: any | null, isFnSkuFBA?: boolean | null, obfuscatedMerchantCustomerId?: string | null, styleCategory?: string | null, optimisticLockId: any, selectionEntryId: string, selectionGroupId: string, selectionMetadataId: string, lastUpdatedTimestamp: any, asin?: string | null, stores?: Array<{ storeID: string, amtStartDate?: any | null, amtEndDate?: any | null, updatedDate?: any | null, presentationStockName?: string | null, inboundMonth?: { month: number, year: number } | null, outboundMonth?: { month: number, year: number } | null }> | null, children?: Array<{ asin?: string | null, size: string, buyUnits?: any | null, salesUnits?: any | null, orderDate?: any | null }> | null, asinMetadata?: { asin: string, title?: string | null, image?: string | null, capacityUnitPerFacing?: { capacity?: number | null, errorMsg?: string | null } | null, uph?: { uphl1?: string | null, uphl2?: string | null, uphl3?: string | null } | null } | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetSelectionResultsQueryVariables = Exact<{
  input: GetSelectionResultsInput;
}>;


export type GetSelectionResultsQuery = { getSelectionResults: { paginationToken?: string | null, selectionResults?: Array<{ __typename: 'AfsSelectionResult', selectionGroupId: string, selectionMetadataId: string, selectionMetadataName?: string | null } | { __typename: 'StyleSelectionResult', selectionGroupName: string, merchLocationName: string, merchLocationId: string, subMerchLocation?: string | null, subMerchLocationId?: string | null, brand?: string | null, season: Season, year: string, selectionGroupId: string, selectionMetadataId: string, selectionMetadataName?: string | null }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetSubcategoryRecommendationQueryVariables = Exact<{
  input: GetSubcategoryRecommendationInput;
}>;


export type GetSubcategoryRecommendationQuery = { getSubcategoryRecommendation: { recommendations?: Array<{ itemId: string, subcategoryId: string, subcategoryName: string, reasonCode: string, reasonDetail: string }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetUserInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInformationQuery = { getUserInformation: { alias?: string | null, allowedStyleMerchLocationGroup?: Array<StyleMerchLocationGroup> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type GetZoneMapConfigQueryVariables = Exact<{
  input: GetZoneMapConfigInput;
}>;


export type GetZoneMapConfigQuery = { getZoneMapConfig: { zoneMapConfig?: { name: string, zones?: Array<{ name: string, fixtures?: Array<{ id: string, fixtureType: string, facings: number }> | null }> | null } | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type ListFloorplansQueryVariables = Exact<{
  input: GetFloorplanInput;
}>;


export type ListFloorplansQuery = { getFloorplan: { floorplans?: Array<{ floorplanId?: string | null, name?: string | null, externalId?: string | null, goLiveDate?: string | null, status?: string | null, isLive: boolean }> | null, error?: { errorMessage: string, errorType?: ErrorType | null } | null } };

export type ValidateMacroplanogramCapacityQueryVariables = Exact<{
  input: ValidateMacroplanogramCapacityInput;
}>;


export type ValidateMacroplanogramCapacityQuery = { validateMacroplanogramCapacity: { capacityValidation?: { totalMacroplanogramVolumeInCubicMillimeters?: number | null, projectedOccupiedVolumeInCubicMillimeters?: number | null, error?: { errorMessage: string } | null } | null } };


export const AddSelectionEntriesDocument = `
    mutation addSelectionEntries($input: AddSelectionEntriesInput!) {
  addSelectionEntries(addSelectionEntriesInput: $input) {
    succeededSelectionEntries {
      selectionEntryId
      optimisticLockId
      isDeleted
    }
    failedSelectionEntries {
      selectionEntryId
      optimisticLockId
      isDeleted
      error {
        errorMessage
        errorType
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useAddSelectionEntriesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSelectionEntriesMutation, TError, AddSelectionEntriesMutationVariables, TContext>) =>
    useMutation<AddSelectionEntriesMutation, TError, AddSelectionEntriesMutationVariables, TContext>(
      ['addSelectionEntries'],
      (variables?: AddSelectionEntriesMutationVariables) => fetcher<AddSelectionEntriesMutation, AddSelectionEntriesMutationVariables>(AddSelectionEntriesDocument, variables)(),
      options
    );
export const ApplyItemsChangeDocument = `
    mutation applyItemsChange($input: ApplyItemsChangeInput!) {
  applyItemsChange(applyItemsChangeInput: $input) {
    errors {
      key
      error {
        errorMessage
        errorType
      }
    }
  }
}
    `;
export const useApplyItemsChangeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApplyItemsChangeMutation, TError, ApplyItemsChangeMutationVariables, TContext>) =>
    useMutation<ApplyItemsChangeMutation, TError, ApplyItemsChangeMutationVariables, TContext>(
      ['applyItemsChange'],
      (variables?: ApplyItemsChangeMutationVariables) => fetcher<ApplyItemsChangeMutation, ApplyItemsChangeMutationVariables>(ApplyItemsChangeDocument, variables)(),
      options
    );
export const BatchSwapAssortmentAcrossZoneDocument = `
    mutation batchSwapAssortmentAcrossZone($input: BatchSwapAssortmentAcrossZoneInput) {
  batchSwapAssortmentAcrossZone(batchSwapAssortmentAcrossZoneInput: $input) {
    errorMap {
      key
      error {
        errorMessage
        errorType
      }
    }
  }
}
    `;
export const useBatchSwapAssortmentAcrossZoneMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BatchSwapAssortmentAcrossZoneMutation, TError, BatchSwapAssortmentAcrossZoneMutationVariables, TContext>) =>
    useMutation<BatchSwapAssortmentAcrossZoneMutation, TError, BatchSwapAssortmentAcrossZoneMutationVariables, TContext>(
      ['batchSwapAssortmentAcrossZone'],
      (variables?: BatchSwapAssortmentAcrossZoneMutationVariables) => fetcher<BatchSwapAssortmentAcrossZoneMutation, BatchSwapAssortmentAcrossZoneMutationVariables>(BatchSwapAssortmentAcrossZoneDocument, variables)(),
      options
    );
export const CreateCategoryDocument = `
    mutation createCategory($input: CreateCategoryInput!) {
  createCategory(createCategoryInput: $input) {
    category {
      categoryId
      categoryName
      extraDimensions
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useCreateCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCategoryMutation, TError, CreateCategoryMutationVariables, TContext>) =>
    useMutation<CreateCategoryMutation, TError, CreateCategoryMutationVariables, TContext>(
      ['createCategory'],
      (variables?: CreateCategoryMutationVariables) => fetcher<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, variables)(),
      options
    );
export const CreateSelectionResultDocument = `
    mutation createSelectionResult($input: CreateSelectionResultInput!) {
  createSelectionResult(createSelectionResultInput: $input) {
    selectionGroupId
    selectionMetadataId
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useCreateSelectionResultMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSelectionResultMutation, TError, CreateSelectionResultMutationVariables, TContext>) =>
    useMutation<CreateSelectionResultMutation, TError, CreateSelectionResultMutationVariables, TContext>(
      ['createSelectionResult'],
      (variables?: CreateSelectionResultMutationVariables) => fetcher<CreateSelectionResultMutation, CreateSelectionResultMutationVariables>(CreateSelectionResultDocument, variables)(),
      options
    );
export const CreateSubcategoryDocument = `
    mutation createSubcategory($input: CreateSubcategoryInput!) {
  createSubcategory(createSubcategoryInput: $input) {
    subcategory {
      subcategoryId
      subcategoryName
      categoryId
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useCreateSubcategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSubcategoryMutation, TError, CreateSubcategoryMutationVariables, TContext>) =>
    useMutation<CreateSubcategoryMutation, TError, CreateSubcategoryMutationVariables, TContext>(
      ['createSubcategory'],
      (variables?: CreateSubcategoryMutationVariables) => fetcher<CreateSubcategoryMutation, CreateSubcategoryMutationVariables>(CreateSubcategoryDocument, variables)(),
      options
    );
export const PublishZoneDocument = `
    mutation publishZone($input: PublishZoneInput) {
  publishZone(publishZoneInput: $input) {
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const usePublishZoneMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PublishZoneMutation, TError, PublishZoneMutationVariables, TContext>) =>
    useMutation<PublishZoneMutation, TError, PublishZoneMutationVariables, TContext>(
      ['publishZone'],
      (variables?: PublishZoneMutationVariables) => fetcher<PublishZoneMutation, PublishZoneMutationVariables>(PublishZoneDocument, variables)(),
      options
    );
export const PutZoneMapConfigDocument = `
    mutation putZoneMapConfig($input: PutZoneMapConfigInput!) {
  putZoneMapConfig(putZoneMapConfigInput: $input) {
    success
    zoneMapConfigId
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const usePutZoneMapConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PutZoneMapConfigMutation, TError, PutZoneMapConfigMutationVariables, TContext>) =>
    useMutation<PutZoneMapConfigMutation, TError, PutZoneMapConfigMutationVariables, TContext>(
      ['putZoneMapConfig'],
      (variables?: PutZoneMapConfigMutationVariables) => fetcher<PutZoneMapConfigMutation, PutZoneMapConfigMutationVariables>(PutZoneMapConfigDocument, variables)(),
      options
    );
export const SwapAssortmentDocument = `
    mutation swapAssortment($input: SwapAssortmentInput) {
  swapAssortment(swapAssortmentInput: $input) {
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useSwapAssortmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SwapAssortmentMutation, TError, SwapAssortmentMutationVariables, TContext>) =>
    useMutation<SwapAssortmentMutation, TError, SwapAssortmentMutationVariables, TContext>(
      ['swapAssortment'],
      (variables?: SwapAssortmentMutationVariables) => fetcher<SwapAssortmentMutation, SwapAssortmentMutationVariables>(SwapAssortmentDocument, variables)(),
      options
    );
export const UpdateFloorplanDocument = `
    mutation UpdateFloorplan($input: UpdateFloorplanInput!) {
  updateFloorplan(input: $input) {
    success
    floorplanId
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useUpdateFloorplanMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFloorplanMutation, TError, UpdateFloorplanMutationVariables, TContext>) =>
    useMutation<UpdateFloorplanMutation, TError, UpdateFloorplanMutationVariables, TContext>(
      ['UpdateFloorplan'],
      (variables?: UpdateFloorplanMutationVariables) => fetcher<UpdateFloorplanMutation, UpdateFloorplanMutationVariables>(UpdateFloorplanDocument, variables)(),
      options
    );
export const UpdateLocalAttributesDocument = `
    mutation updateLocalAttributes($input: UpdateLocalAttributesInput!) {
  updateLocalAttributes(updateLocalAttributesInput: $input) {
    succeededItems {
      optimisticLockId
      selectionEntryId
      itemIdWithType {
        id
        type
      }
    }
    failedItems {
      selectionEntryId
      itemIdWithType {
        id
        type
      }
      error {
        errorMessage
        errorType
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useUpdateLocalAttributesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLocalAttributesMutation, TError, UpdateLocalAttributesMutationVariables, TContext>) =>
    useMutation<UpdateLocalAttributesMutation, TError, UpdateLocalAttributesMutationVariables, TContext>(
      ['updateLocalAttributes'],
      (variables?: UpdateLocalAttributesMutationVariables) => fetcher<UpdateLocalAttributesMutation, UpdateLocalAttributesMutationVariables>(UpdateLocalAttributesDocument, variables)(),
      options
    );
export const UpdateSelectionEntriesDocument = `
    mutation updateSelectionEntries($input: UpdateSelectionEntriesInput!) {
  updateSelectionEntries(updateSelectionEntriesInput: $input) {
    succeededSelectionEntries {
      selectionEntryId
      optimisticLockId
      isDeleted
    }
    failedSelectionEntries {
      selectionEntryId
      optimisticLockId
      isDeleted
      error {
        errorMessage
        errorType
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useUpdateSelectionEntriesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSelectionEntriesMutation, TError, UpdateSelectionEntriesMutationVariables, TContext>) =>
    useMutation<UpdateSelectionEntriesMutation, TError, UpdateSelectionEntriesMutationVariables, TContext>(
      ['updateSelectionEntries'],
      (variables?: UpdateSelectionEntriesMutationVariables) => fetcher<UpdateSelectionEntriesMutation, UpdateSelectionEntriesMutationVariables>(UpdateSelectionEntriesDocument, variables)(),
      options
    );
export const GetAmtInboundOutboundMappingDocument = `
    query getAMTInboundOutboundMapping {
  getAMTInboundOutboundMapping {
    inboundMonthMapping {
      monthAndYear {
        month
        year
      }
      amtDates {
        date
        id
      }
    }
    outboundMonthMapping {
      monthAndYear {
        month
        year
      }
      amtDates {
        date
        id
      }
    }
  }
}
    `;
export const useGetAmtInboundOutboundMappingQuery = <
      TData = GetAmtInboundOutboundMappingQuery,
      TError = unknown
    >(
      variables?: GetAmtInboundOutboundMappingQueryVariables,
      options?: UseQueryOptions<GetAmtInboundOutboundMappingQuery, TError, TData>
    ) =>
    useQuery<GetAmtInboundOutboundMappingQuery, TError, TData>(
      variables === undefined ? ['getAMTInboundOutboundMapping'] : ['getAMTInboundOutboundMapping', variables],
      fetcher<GetAmtInboundOutboundMappingQuery, GetAmtInboundOutboundMappingQueryVariables>(GetAmtInboundOutboundMappingDocument, variables),
      options
    );
export const useInfiniteGetAmtInboundOutboundMappingQuery = <
      TData = GetAmtInboundOutboundMappingQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAmtInboundOutboundMappingQueryVariables,
      variables?: GetAmtInboundOutboundMappingQueryVariables,
      options?: UseInfiniteQueryOptions<GetAmtInboundOutboundMappingQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAmtInboundOutboundMappingQuery, TError, TData>(
      variables === undefined ? ['getAMTInboundOutboundMapping.infinite'] : ['getAMTInboundOutboundMapping.infinite', variables],
      (metaData) => fetcher<GetAmtInboundOutboundMappingQuery, GetAmtInboundOutboundMappingQueryVariables>(GetAmtInboundOutboundMappingDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetAsinMetadataDocument = `
    query GetAsinMetadata($input: GetAsinMetadataInput!) {
  getAsinMetadata(getAsinMetadataInput: $input) {
    asinMetadata {
      asin
      capacityUnitPerFacing {
        capacity
        jumbleFactor
        errorMsg
      }
      title
      image
      uph {
        uphl1
        uphl2
        uphl3
      }
      procurable
      buyable
      temperatureRating
      performanceData {
        shrinkCost
        shrinkPerOps
        shrinkPerOps13week
        shrinkPerOps26week
        shrinkPerOps52week
        movingAvgSales13week
        movingAvgSales26week
        movingAvgSales52week
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetAsinMetadataQuery = <
      TData = GetAsinMetadataQuery,
      TError = unknown
    >(
      variables: GetAsinMetadataQueryVariables,
      options?: UseQueryOptions<GetAsinMetadataQuery, TError, TData>
    ) =>
    useQuery<GetAsinMetadataQuery, TError, TData>(
      ['GetAsinMetadata', variables],
      fetcher<GetAsinMetadataQuery, GetAsinMetadataQueryVariables>(GetAsinMetadataDocument, variables),
      options
    );
export const useInfiniteGetAsinMetadataQuery = <
      TData = GetAsinMetadataQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAsinMetadataQueryVariables,
      variables: GetAsinMetadataQueryVariables,
      options?: UseInfiniteQueryOptions<GetAsinMetadataQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAsinMetadataQuery, TError, TData>(
      ['GetAsinMetadata.infinite', variables],
      (metaData) => fetcher<GetAsinMetadataQuery, GetAsinMetadataQueryVariables>(GetAsinMetadataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetPrsDataDocument = `
    query getPrsData($input: GetAsinMetadataInput!) {
  getAsinMetadata(getAsinMetadataInput: $input) {
    asinMetadata {
      asin
      title
      image
      unitPrice {
        unit
        price {
          unit
          value
        }
      }
      ourPrice {
        unit
        value
      }
      menuImage
      packageVariantsImage
      upc
      upce
      gtin
      ean
      plu
      techCompatibilities
      productStackableForAtlas
      productStackableForLWP
      springTensionForAF
      maxProductsInLaneForAF
      tidyOrientations {
        orientation
        rotation
        shelfTech
      }
      merchandisingRestrictions
      dimensions {
        heightInMillimeters
        lengthInMillimeters
        widthInMillimeters
      }
      weightInGrams
      isSearchable
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetPrsDataQuery = <
      TData = GetPrsDataQuery,
      TError = unknown
    >(
      variables: GetPrsDataQueryVariables,
      options?: UseQueryOptions<GetPrsDataQuery, TError, TData>
    ) =>
    useQuery<GetPrsDataQuery, TError, TData>(
      ['getPrsData', variables],
      fetcher<GetPrsDataQuery, GetPrsDataQueryVariables>(GetPrsDataDocument, variables),
      options
    );
export const useInfiniteGetPrsDataQuery = <
      TData = GetPrsDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetPrsDataQueryVariables,
      variables: GetPrsDataQueryVariables,
      options?: UseInfiniteQueryOptions<GetPrsDataQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetPrsDataQuery, TError, TData>(
      ['getPrsData.infinite', variables],
      (metaData) => fetcher<GetPrsDataQuery, GetPrsDataQueryVariables>(GetPrsDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetAssortmentDiffDocument = `
    query GetAssortmentDiff($input: GetAssortmentDiffInput!) {
  getAssortmentDiff(getAssortmentDiffInput: $input) {
    assortmentRecommendations {
      asin
      entryId
      startTime
      endTime
      subcategoryId
      macroplanogramId
      facingUnits
      fohCapacity
      asinMetadata {
        asin
        title
        image
        uph {
          uphl1
          uphl2
          uphl3
        }
        capacityUnitPerFacing {
          capacity
          errorMsg
          jumbleFactor
        }
        procurable
        buyable
        temperatureRating
        performanceData {
          shrinkCost
          shrinkPerOps
          shrinkPerOps13week
          shrinkPerOps26week
          shrinkPerOps52week
          movingAvgSales13week
          movingAvgSales26week
          movingAvgSales52week
        }
      }
      recommendedAction {
        action
        note
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetAssortmentDiffQuery = <
      TData = GetAssortmentDiffQuery,
      TError = unknown
    >(
      variables: GetAssortmentDiffQueryVariables,
      options?: UseQueryOptions<GetAssortmentDiffQuery, TError, TData>
    ) =>
    useQuery<GetAssortmentDiffQuery, TError, TData>(
      ['GetAssortmentDiff', variables],
      fetcher<GetAssortmentDiffQuery, GetAssortmentDiffQueryVariables>(GetAssortmentDiffDocument, variables),
      options
    );
export const useInfiniteGetAssortmentDiffQuery = <
      TData = GetAssortmentDiffQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAssortmentDiffQueryVariables,
      variables: GetAssortmentDiffQueryVariables,
      options?: UseInfiniteQueryOptions<GetAssortmentDiffQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAssortmentDiffQuery, TError, TData>(
      ['GetAssortmentDiff.infinite', variables],
      (metaData) => fetcher<GetAssortmentDiffQuery, GetAssortmentDiffQueryVariables>(GetAssortmentDiffDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetAssortmentSwapRecommendationsDocument = `
    query getAssortmentSwapRecommendations($input: GetAssortmentSwapRecommendationsInput!) {
  getAssortmentSwapRecommendations(getAssortmentSwapRecommendationsInput: $input) {
    facingUnitsToRemove
    maxFacingUnits
    occupiedFacingUnits
    swapRecommendations {
      asin
      entryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      storeId
      facingUnits
      fohCapacity
      asinMetadata {
        asin
        title
        image
        uph {
          uphl1
          uphl2
          uphl3
        }
        performanceData {
          shrinkCost
          shrinkPerOps
          shrinkPerOps13week
          shrinkPerOps26week
          shrinkPerOps52week
          movingAvgSales13week
          movingAvgSales26week
          movingAvgSales52week
        }
      }
    }
  }
}
    `;
export const useGetAssortmentSwapRecommendationsQuery = <
      TData = GetAssortmentSwapRecommendationsQuery,
      TError = unknown
    >(
      variables: GetAssortmentSwapRecommendationsQueryVariables,
      options?: UseQueryOptions<GetAssortmentSwapRecommendationsQuery, TError, TData>
    ) =>
    useQuery<GetAssortmentSwapRecommendationsQuery, TError, TData>(
      ['getAssortmentSwapRecommendations', variables],
      fetcher<GetAssortmentSwapRecommendationsQuery, GetAssortmentSwapRecommendationsQueryVariables>(GetAssortmentSwapRecommendationsDocument, variables),
      options
    );
export const useInfiniteGetAssortmentSwapRecommendationsQuery = <
      TData = GetAssortmentSwapRecommendationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAssortmentSwapRecommendationsQueryVariables,
      variables: GetAssortmentSwapRecommendationsQueryVariables,
      options?: UseInfiniteQueryOptions<GetAssortmentSwapRecommendationsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetAssortmentSwapRecommendationsQuery, TError, TData>(
      ['getAssortmentSwapRecommendations.infinite', variables],
      (metaData) => fetcher<GetAssortmentSwapRecommendationsQuery, GetAssortmentSwapRecommendationsQueryVariables>(GetAssortmentSwapRecommendationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetBatchAssortmentSwapRecommendationsDocument = `
    query getBatchAssortmentSwapRecommendations($input: GetBatchAssortmentSwapRecommendationsInput!) {
  getBatchAssortmentSwapRecommendations(
    getBatchAssortmentSwapRecommendationsInput: $input
  ) {
    swapRecommendations {
      facingUnitsToRemove
      maxFacingUnits
      occupiedFacingUnits
      macroplanogramId
      swapRecommendations {
        asin
        entryId
        subcategoryId
        macroplanogramId
        startTime
        endTime
        storeId
        facingUnits
        fohCapacity
        asinMetadata {
          asin
          capacityUnitPerFacing {
            capacity
            errorMsg
          }
          title
          image
          uph {
            uphl1
            uphl2
            uphl3
          }
          performanceData {
            shrinkCost
            shrinkPerOps
            shrinkPerOps13week
            shrinkPerOps26week
            shrinkPerOps52week
            movingAvgSales13week
            movingAvgSales26week
            movingAvgSales52week
          }
        }
      }
    }
    errorMap {
      key
      error {
        errorMessage
        errorType
      }
    }
  }
}
    `;
export const useGetBatchAssortmentSwapRecommendationsQuery = <
      TData = GetBatchAssortmentSwapRecommendationsQuery,
      TError = unknown
    >(
      variables: GetBatchAssortmentSwapRecommendationsQueryVariables,
      options?: UseQueryOptions<GetBatchAssortmentSwapRecommendationsQuery, TError, TData>
    ) =>
    useQuery<GetBatchAssortmentSwapRecommendationsQuery, TError, TData>(
      ['getBatchAssortmentSwapRecommendations', variables],
      fetcher<GetBatchAssortmentSwapRecommendationsQuery, GetBatchAssortmentSwapRecommendationsQueryVariables>(GetBatchAssortmentSwapRecommendationsDocument, variables),
      options
    );
export const useInfiniteGetBatchAssortmentSwapRecommendationsQuery = <
      TData = GetBatchAssortmentSwapRecommendationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetBatchAssortmentSwapRecommendationsQueryVariables,
      variables: GetBatchAssortmentSwapRecommendationsQueryVariables,
      options?: UseInfiniteQueryOptions<GetBatchAssortmentSwapRecommendationsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetBatchAssortmentSwapRecommendationsQuery, TError, TData>(
      ['getBatchAssortmentSwapRecommendations.infinite', variables],
      (metaData) => fetcher<GetBatchAssortmentSwapRecommendationsQuery, GetBatchAssortmentSwapRecommendationsQueryVariables>(GetBatchAssortmentSwapRecommendationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetCategoryDocument = `
    query GetCategory($input: GetCategoryInput) {
  getCategory(getCategoryInput: $input) {
    category {
      categoryId
      categoryName
      extraDimensions
    }
    subcategory {
      subcategoryId
      subcategoryName
      categoryId
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetCategoryQuery = <
      TData = GetCategoryQuery,
      TError = unknown
    >(
      variables?: GetCategoryQueryVariables,
      options?: UseQueryOptions<GetCategoryQuery, TError, TData>
    ) =>
    useQuery<GetCategoryQuery, TError, TData>(
      variables === undefined ? ['GetCategory'] : ['GetCategory', variables],
      fetcher<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, variables),
      options
    );
export const useInfiniteGetCategoryQuery = <
      TData = GetCategoryQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCategoryQueryVariables,
      variables?: GetCategoryQueryVariables,
      options?: UseInfiniteQueryOptions<GetCategoryQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetCategoryQuery, TError, TData>(
      variables === undefined ? ['GetCategory.infinite'] : ['GetCategory.infinite', variables],
      (metaData) => fetcher<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetFloorplanDocument = `
    query GetFloorplan($input: GetFloorplanInput!) {
  getFloorplan(getFloorplanInput: $input) {
    floorplans {
      floorplanId
      goLiveDate
      status
      fixtures {
        id
        model
        height
        width
        depth
        rotation
        translation
        department
        categories
        isAgile
        fixtureType
        pickPathId
        tempZone
        dropZone
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetFloorplanQuery = <
      TData = GetFloorplanQuery,
      TError = unknown
    >(
      variables: GetFloorplanQueryVariables,
      options?: UseQueryOptions<GetFloorplanQuery, TError, TData>
    ) =>
    useQuery<GetFloorplanQuery, TError, TData>(
      ['GetFloorplan', variables],
      fetcher<GetFloorplanQuery, GetFloorplanQueryVariables>(GetFloorplanDocument, variables),
      options
    );
export const useInfiniteGetFloorplanQuery = <
      TData = GetFloorplanQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetFloorplanQueryVariables,
      variables: GetFloorplanQueryVariables,
      options?: UseInfiniteQueryOptions<GetFloorplanQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetFloorplanQuery, TError, TData>(
      ['GetFloorplan.infinite', variables],
      (metaData) => fetcher<GetFloorplanQuery, GetFloorplanQueryVariables>(GetFloorplanDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetItemEntriesDocument = `
    query GetItemEntries($input: GetItemEntriesInput!) {
  getItemEntries(getItemEntriesInput: $input) {
    items {
      itemId
      itemType
      entryId
      optimisticLockId
      categoryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      storeId
      itemMetaDataEntry {
        itemId
        itemType
        title
        image
      }
    }
    paginationToken
  }
}
    `;
export const useGetItemEntriesQuery = <
      TData = GetItemEntriesQuery,
      TError = unknown
    >(
      variables: GetItemEntriesQueryVariables,
      options?: UseQueryOptions<GetItemEntriesQuery, TError, TData>
    ) =>
    useQuery<GetItemEntriesQuery, TError, TData>(
      ['GetItemEntries', variables],
      fetcher<GetItemEntriesQuery, GetItemEntriesQueryVariables>(GetItemEntriesDocument, variables),
      options
    );
export const useInfiniteGetItemEntriesQuery = <
      TData = GetItemEntriesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetItemEntriesQueryVariables,
      variables: GetItemEntriesQueryVariables,
      options?: UseInfiniteQueryOptions<GetItemEntriesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetItemEntriesQuery, TError, TData>(
      ['GetItemEntries.infinite', variables],
      (metaData) => fetcher<GetItemEntriesQuery, GetItemEntriesQueryVariables>(GetItemEntriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetItemMetaDataDocument = `
    query GetItemMetaData($input: GetItemMetaDataInput!) {
  getItemMetaData(getItemMetaDataInput: $input) {
    items {
      itemId
      itemType
      title
      image
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetItemMetaDataQuery = <
      TData = GetItemMetaDataQuery,
      TError = unknown
    >(
      variables: GetItemMetaDataQueryVariables,
      options?: UseQueryOptions<GetItemMetaDataQuery, TError, TData>
    ) =>
    useQuery<GetItemMetaDataQuery, TError, TData>(
      ['GetItemMetaData', variables],
      fetcher<GetItemMetaDataQuery, GetItemMetaDataQueryVariables>(GetItemMetaDataDocument, variables),
      options
    );
export const useInfiniteGetItemMetaDataQuery = <
      TData = GetItemMetaDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetItemMetaDataQueryVariables,
      variables: GetItemMetaDataQueryVariables,
      options?: UseInfiniteQueryOptions<GetItemMetaDataQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetItemMetaDataQuery, TError, TData>(
      ['GetItemMetaData.infinite', variables],
      (metaData) => fetcher<GetItemMetaDataQuery, GetItemMetaDataQueryVariables>(GetItemMetaDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetMacroAssortmentDocument = `
    query GetMacroAssortment($input: GetMacroAssortmentInput!) {
  getMacroAssortment(getMacroAssortmentInput: $input) {
    assortment {
      asin
      entryId
      categoryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      storeId
      facingUnits
      fohCapacity
      locationNotes
      asinMetadata {
        asin
        title
        image
        uph {
          uphl1
          uphl2
          uphl3
        }
        performanceData {
          shrinkCost
          shrinkPerOps
          shrinkPerOps13week
          shrinkPerOps26week
          shrinkPerOps52week
          movingAvgSales13week
          movingAvgSales26week
          movingAvgSales52week
        }
      }
    }
    paginationToken
  }
}
    `;
export const useGetMacroAssortmentQuery = <
      TData = GetMacroAssortmentQuery,
      TError = unknown
    >(
      variables: GetMacroAssortmentQueryVariables,
      options?: UseQueryOptions<GetMacroAssortmentQuery, TError, TData>
    ) =>
    useQuery<GetMacroAssortmentQuery, TError, TData>(
      ['GetMacroAssortment', variables],
      fetcher<GetMacroAssortmentQuery, GetMacroAssortmentQueryVariables>(GetMacroAssortmentDocument, variables),
      options
    );
export const useInfiniteGetMacroAssortmentQuery = <
      TData = GetMacroAssortmentQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMacroAssortmentQueryVariables,
      variables: GetMacroAssortmentQueryVariables,
      options?: UseInfiniteQueryOptions<GetMacroAssortmentQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetMacroAssortmentQuery, TError, TData>(
      ['GetMacroAssortment.infinite', variables],
      (metaData) => fetcher<GetMacroAssortmentQuery, GetMacroAssortmentQueryVariables>(GetMacroAssortmentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetMacroplanogramDocument = `
    query getMacroplanogram($input: GetMacroplanogramInput!) {
  getMacroplanogram(getMacroplanogramInput: $input) {
    macroplanogram {
      entryId
      macroplanogramName
      startTime
      endTime
      storeId
      storeSubcategories {
        subcategoryName
        subcategoryId
        zoneFixtureIds
        maxFacingUnits
        capacityPercentage
        isCapacityOverrideAllowed
      }
      fixtureIds
      maxFacingUnits
      isCapacityOverrideAllowed
      isDraft
      zoneMapConfigId
      linkId
      categoryId
    }
  }
}
    `;
export const useGetMacroplanogramQuery = <
      TData = GetMacroplanogramQuery,
      TError = unknown
    >(
      variables: GetMacroplanogramQueryVariables,
      options?: UseQueryOptions<GetMacroplanogramQuery, TError, TData>
    ) =>
    useQuery<GetMacroplanogramQuery, TError, TData>(
      ['getMacroplanogram', variables],
      fetcher<GetMacroplanogramQuery, GetMacroplanogramQueryVariables>(GetMacroplanogramDocument, variables),
      options
    );
export const useInfiniteGetMacroplanogramQuery = <
      TData = GetMacroplanogramQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMacroplanogramQueryVariables,
      variables: GetMacroplanogramQueryVariables,
      options?: UseInfiniteQueryOptions<GetMacroplanogramQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetMacroplanogramQuery, TError, TData>(
      ['getMacroplanogram.infinite', variables],
      (metaData) => fetcher<GetMacroplanogramQuery, GetMacroplanogramQueryVariables>(GetMacroplanogramDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetPlanDiffDocument = `
    query GetPlanDiff($input: GetPlanDiffInput!) {
  getPlanDiff(getPlanDiffInput: $input) {
    newEntries {
      itemId
      itemType
      categoryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      itemMetaDataEntry {
        itemId
        itemType
        title
        image
      }
    }
    endedEntries {
      entryId
      optimisticLockId
      itemId
      itemType
      categoryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      itemMetaDataEntry {
        itemId
        itemType
        title
        image
      }
    }
    extendedEntries {
      entryId
      optimisticLockId
      itemId
      itemType
      categoryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      itemMetaDataEntry {
        itemId
        itemType
        title
        image
      }
    }
    deletedEntries {
      entryId
      optimisticLockId
      itemId
      itemType
      categoryId
      subcategoryId
      macroplanogramId
      startTime
      endTime
      itemMetaDataEntry {
        itemId
        itemType
        title
        image
      }
    }
  }
}
    `;
export const useGetPlanDiffQuery = <
      TData = GetPlanDiffQuery,
      TError = unknown
    >(
      variables: GetPlanDiffQueryVariables,
      options?: UseQueryOptions<GetPlanDiffQuery, TError, TData>
    ) =>
    useQuery<GetPlanDiffQuery, TError, TData>(
      ['GetPlanDiff', variables],
      fetcher<GetPlanDiffQuery, GetPlanDiffQueryVariables>(GetPlanDiffDocument, variables),
      options
    );
export const useInfiniteGetPlanDiffQuery = <
      TData = GetPlanDiffQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetPlanDiffQueryVariables,
      variables: GetPlanDiffQueryVariables,
      options?: UseInfiniteQueryOptions<GetPlanDiffQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetPlanDiffQuery, TError, TData>(
      ['GetPlanDiff.infinite', variables],
      (metaData) => fetcher<GetPlanDiffQuery, GetPlanDiffQueryVariables>(GetPlanDiffDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetProductGroupsDocument = `
    query GetProductGroups {
  getProductGroups {
    productGroups {
      productGroupId
      productGroupName
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetProductGroupsQuery = <
      TData = GetProductGroupsQuery,
      TError = unknown
    >(
      variables?: GetProductGroupsQueryVariables,
      options?: UseQueryOptions<GetProductGroupsQuery, TError, TData>
    ) =>
    useQuery<GetProductGroupsQuery, TError, TData>(
      variables === undefined ? ['GetProductGroups'] : ['GetProductGroups', variables],
      fetcher<GetProductGroupsQuery, GetProductGroupsQueryVariables>(GetProductGroupsDocument, variables),
      options
    );
export const useInfiniteGetProductGroupsQuery = <
      TData = GetProductGroupsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetProductGroupsQueryVariables,
      variables?: GetProductGroupsQueryVariables,
      options?: UseInfiniteQueryOptions<GetProductGroupsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetProductGroupsQuery, TError, TData>(
      variables === undefined ? ['GetProductGroups.infinite'] : ['GetProductGroups.infinite', variables],
      (metaData) => fetcher<GetProductGroupsQuery, GetProductGroupsQueryVariables>(GetProductGroupsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetProgramStoresDocument = `
    query GetProgramStores {
  getProgramStores {
    stores {
      storeId
      warehouseId
      launchDate
      storeCode
      storeName
    }
  }
}
    `;
export const useGetProgramStoresQuery = <
      TData = GetProgramStoresQuery,
      TError = unknown
    >(
      variables?: GetProgramStoresQueryVariables,
      options?: UseQueryOptions<GetProgramStoresQuery, TError, TData>
    ) =>
    useQuery<GetProgramStoresQuery, TError, TData>(
      variables === undefined ? ['GetProgramStores'] : ['GetProgramStores', variables],
      fetcher<GetProgramStoresQuery, GetProgramStoresQueryVariables>(GetProgramStoresDocument, variables),
      options
    );
export const useInfiniteGetProgramStoresQuery = <
      TData = GetProgramStoresQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetProgramStoresQueryVariables,
      variables?: GetProgramStoresQueryVariables,
      options?: UseInfiniteQueryOptions<GetProgramStoresQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetProgramStoresQuery, TError, TData>(
      variables === undefined ? ['GetProgramStores.infinite'] : ['GetProgramStores.infinite', variables],
      (metaData) => fetcher<GetProgramStoresQuery, GetProgramStoresQueryVariables>(GetProgramStoresDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetSelectionEntriesForSelectionResultDocument = `
    query getSelectionEntriesForSelectionResult($input: GetSelectionEntriesInput!) {
  getSelectionEntriesForSelectionResult(getSelectionEntriesInput: $input) {
    selectionEntries {
      __typename
      optimisticLockId
      selectionEntryId
      selectionGroupId
      selectionMetadataId
      lastUpdatedTimestamp
      asin
      asinMetadata {
        asin
        capacityUnitPerFacing {
          capacity
          errorMsg
        }
        title
        image
        uph {
          uphl1
          uphl2
          uphl3
        }
      }
      ... on StyleSelectionEntry {
        imageUrl
        addedDate
        teenAsin
        productPlaceholder
        vendorPlaceholder
        brand
        vendorCode
        relationship
        status
        parentAsin
        exampleChildAsin
        childAsinSizes
        vendorStyle
        styleName
        vendorColor
        simpleColor
        price
        newness
        availableRetailDate
        shipWindowStartDate
        shipWindowEndDate
        isFastTrack
        notes
        GL
        department
        merchLocation
        subMerchLocation
        door
        stores {
          storeID
          amtStartDate
          amtEndDate
          inboundMonth {
            month
            year
          }
          outboundMonth {
            month
            year
          }
          updatedDate
          presentationStockName
        }
        styleZoneName
        isFeaturedMerch
        matchingSetName
        silhouette
        riseForDenim
        primaryStory
        styleRank
        colorRank
        isFnSkuFBA
        obfuscatedMerchantCustomerId
        children {
          asin
          size
          buyUnits
          salesUnits
          orderDate
        }
        styleCategory
      }
    }
    selectionEntriesPaginationToken
    totalEntries
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetSelectionEntriesForSelectionResultQuery = <
      TData = GetSelectionEntriesForSelectionResultQuery,
      TError = unknown
    >(
      variables: GetSelectionEntriesForSelectionResultQueryVariables,
      options?: UseQueryOptions<GetSelectionEntriesForSelectionResultQuery, TError, TData>
    ) =>
    useQuery<GetSelectionEntriesForSelectionResultQuery, TError, TData>(
      ['getSelectionEntriesForSelectionResult', variables],
      fetcher<GetSelectionEntriesForSelectionResultQuery, GetSelectionEntriesForSelectionResultQueryVariables>(GetSelectionEntriesForSelectionResultDocument, variables),
      options
    );
export const useInfiniteGetSelectionEntriesForSelectionResultQuery = <
      TData = GetSelectionEntriesForSelectionResultQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSelectionEntriesForSelectionResultQueryVariables,
      variables: GetSelectionEntriesForSelectionResultQueryVariables,
      options?: UseInfiniteQueryOptions<GetSelectionEntriesForSelectionResultQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetSelectionEntriesForSelectionResultQuery, TError, TData>(
      ['getSelectionEntriesForSelectionResult.infinite', variables],
      (metaData) => fetcher<GetSelectionEntriesForSelectionResultQuery, GetSelectionEntriesForSelectionResultQueryVariables>(GetSelectionEntriesForSelectionResultDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetSelectionResultsDocument = `
    query getSelectionResults($input: GetSelectionResultsInput!) {
  getSelectionResults(getSelectionResultsInput: $input) {
    selectionResults {
      __typename
      selectionGroupId
      selectionMetadataId
      selectionMetadataName
      ... on StyleSelectionResult {
        selectionGroupName
        merchLocationName
        merchLocationId
        subMerchLocation
        subMerchLocationId
        brand
        season
        year
      }
    }
    paginationToken
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetSelectionResultsQuery = <
      TData = GetSelectionResultsQuery,
      TError = unknown
    >(
      variables: GetSelectionResultsQueryVariables,
      options?: UseQueryOptions<GetSelectionResultsQuery, TError, TData>
    ) =>
    useQuery<GetSelectionResultsQuery, TError, TData>(
      ['getSelectionResults', variables],
      fetcher<GetSelectionResultsQuery, GetSelectionResultsQueryVariables>(GetSelectionResultsDocument, variables),
      options
    );
export const useInfiniteGetSelectionResultsQuery = <
      TData = GetSelectionResultsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSelectionResultsQueryVariables,
      variables: GetSelectionResultsQueryVariables,
      options?: UseInfiniteQueryOptions<GetSelectionResultsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetSelectionResultsQuery, TError, TData>(
      ['getSelectionResults.infinite', variables],
      (metaData) => fetcher<GetSelectionResultsQuery, GetSelectionResultsQueryVariables>(GetSelectionResultsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetSubcategoryRecommendationDocument = `
    query GetSubcategoryRecommendation($input: GetSubcategoryRecommendationInput!) {
  getSubcategoryRecommendation(getSubcategoryRecommendationInput: $input) {
    recommendations {
      itemId
      subcategoryId
      subcategoryName
      reasonCode
      reasonDetail
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetSubcategoryRecommendationQuery = <
      TData = GetSubcategoryRecommendationQuery,
      TError = unknown
    >(
      variables: GetSubcategoryRecommendationQueryVariables,
      options?: UseQueryOptions<GetSubcategoryRecommendationQuery, TError, TData>
    ) =>
    useQuery<GetSubcategoryRecommendationQuery, TError, TData>(
      ['GetSubcategoryRecommendation', variables],
      fetcher<GetSubcategoryRecommendationQuery, GetSubcategoryRecommendationQueryVariables>(GetSubcategoryRecommendationDocument, variables),
      options
    );
export const useInfiniteGetSubcategoryRecommendationQuery = <
      TData = GetSubcategoryRecommendationQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSubcategoryRecommendationQueryVariables,
      variables: GetSubcategoryRecommendationQueryVariables,
      options?: UseInfiniteQueryOptions<GetSubcategoryRecommendationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetSubcategoryRecommendationQuery, TError, TData>(
      ['GetSubcategoryRecommendation.infinite', variables],
      (metaData) => fetcher<GetSubcategoryRecommendationQuery, GetSubcategoryRecommendationQueryVariables>(GetSubcategoryRecommendationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetUserInformationDocument = `
    query getUserInformation {
  getUserInformation {
    alias
    allowedStyleMerchLocationGroup
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetUserInformationQuery = <
      TData = GetUserInformationQuery,
      TError = unknown
    >(
      variables?: GetUserInformationQueryVariables,
      options?: UseQueryOptions<GetUserInformationQuery, TError, TData>
    ) =>
    useQuery<GetUserInformationQuery, TError, TData>(
      variables === undefined ? ['getUserInformation'] : ['getUserInformation', variables],
      fetcher<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, variables),
      options
    );
export const useInfiniteGetUserInformationQuery = <
      TData = GetUserInformationQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetUserInformationQueryVariables,
      variables?: GetUserInformationQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserInformationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetUserInformationQuery, TError, TData>(
      variables === undefined ? ['getUserInformation.infinite'] : ['getUserInformation.infinite', variables],
      (metaData) => fetcher<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const GetZoneMapConfigDocument = `
    query GetZoneMapConfig($input: GetZoneMapConfigInput!) {
  getZoneMapConfig(getZoneMapConfigInput: $input) {
    zoneMapConfig {
      name
      zones {
        name
        fixtures {
          id
          fixtureType
          facings
        }
      }
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useGetZoneMapConfigQuery = <
      TData = GetZoneMapConfigQuery,
      TError = unknown
    >(
      variables: GetZoneMapConfigQueryVariables,
      options?: UseQueryOptions<GetZoneMapConfigQuery, TError, TData>
    ) =>
    useQuery<GetZoneMapConfigQuery, TError, TData>(
      ['GetZoneMapConfig', variables],
      fetcher<GetZoneMapConfigQuery, GetZoneMapConfigQueryVariables>(GetZoneMapConfigDocument, variables),
      options
    );
export const useInfiniteGetZoneMapConfigQuery = <
      TData = GetZoneMapConfigQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetZoneMapConfigQueryVariables,
      variables: GetZoneMapConfigQueryVariables,
      options?: UseInfiniteQueryOptions<GetZoneMapConfigQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetZoneMapConfigQuery, TError, TData>(
      ['GetZoneMapConfig.infinite', variables],
      (metaData) => fetcher<GetZoneMapConfigQuery, GetZoneMapConfigQueryVariables>(GetZoneMapConfigDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ListFloorplansDocument = `
    query ListFloorplans($input: GetFloorplanInput!) {
  getFloorplan(getFloorplanInput: $input) {
    floorplans {
      floorplanId
      name
      externalId
      goLiveDate
      status
      isLive
    }
    error {
      errorMessage
      errorType
    }
  }
}
    `;
export const useListFloorplansQuery = <
      TData = ListFloorplansQuery,
      TError = unknown
    >(
      variables: ListFloorplansQueryVariables,
      options?: UseQueryOptions<ListFloorplansQuery, TError, TData>
    ) =>
    useQuery<ListFloorplansQuery, TError, TData>(
      ['ListFloorplans', variables],
      fetcher<ListFloorplansQuery, ListFloorplansQueryVariables>(ListFloorplansDocument, variables),
      options
    );
export const useInfiniteListFloorplansQuery = <
      TData = ListFloorplansQuery,
      TError = unknown
    >(
      pageParamKey: keyof ListFloorplansQueryVariables,
      variables: ListFloorplansQueryVariables,
      options?: UseInfiniteQueryOptions<ListFloorplansQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ListFloorplansQuery, TError, TData>(
      ['ListFloorplans.infinite', variables],
      (metaData) => fetcher<ListFloorplansQuery, ListFloorplansQueryVariables>(ListFloorplansDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ValidateMacroplanogramCapacityDocument = `
    query ValidateMacroplanogramCapacity($input: ValidateMacroplanogramCapacityInput!) {
  validateMacroplanogramCapacity(validateMacroplanogramCapacityInput: $input) {
    capacityValidation {
      totalMacroplanogramVolumeInCubicMillimeters
      projectedOccupiedVolumeInCubicMillimeters
      error {
        errorMessage
      }
    }
  }
}
    `;
export const useValidateMacroplanogramCapacityQuery = <
      TData = ValidateMacroplanogramCapacityQuery,
      TError = unknown
    >(
      variables: ValidateMacroplanogramCapacityQueryVariables,
      options?: UseQueryOptions<ValidateMacroplanogramCapacityQuery, TError, TData>
    ) =>
    useQuery<ValidateMacroplanogramCapacityQuery, TError, TData>(
      ['ValidateMacroplanogramCapacity', variables],
      fetcher<ValidateMacroplanogramCapacityQuery, ValidateMacroplanogramCapacityQueryVariables>(ValidateMacroplanogramCapacityDocument, variables),
      options
    );
export const useInfiniteValidateMacroplanogramCapacityQuery = <
      TData = ValidateMacroplanogramCapacityQuery,
      TError = unknown
    >(
      pageParamKey: keyof ValidateMacroplanogramCapacityQueryVariables,
      variables: ValidateMacroplanogramCapacityQueryVariables,
      options?: UseInfiniteQueryOptions<ValidateMacroplanogramCapacityQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ValidateMacroplanogramCapacityQuery, TError, TData>(
      ['ValidateMacroplanogramCapacity.infinite', variables],
      (metaData) => fetcher<ValidateMacroplanogramCapacityQuery, ValidateMacroplanogramCapacityQueryVariables>(ValidateMacroplanogramCapacityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};
